export * from '../models/AccessCondition';
export * from '../models/AccessConditionEffect';
export * from '../models/AccessConditionalExpression';
export * from '../models/Account';
export * from '../models/AccountConfigInput';
export * from '../models/AccountIdCondition';
export * from '../models/AccountIdFilters';
export * from '../models/AccountInstallationMethod';
export * from '../models/AccountMetricsDestination';
export * from '../models/AccountNameFilters';
export * from '../models/AccountState';
export * from '../models/AccountStatusFilters';
export * from '../models/AccountUpdateInput';
export * from '../models/AccountVersion';
export * from '../models/ActionFilters';
export * from '../models/ActionRequiredDetails';
export * from '../models/ActivateGcpFolderResponse';
export * from '../models/ActivateGcpOrganizationResponse';
export * from '../models/Ami';
export * from '../models/AmiBlockDevice';
export * from '../models/AnnuallyConfig';
export * from '../models/ApiCredentials';
export * from '../models/ApiCredentialsProperties';
export * from '../models/App';
export * from '../models/AppFilters';
export * from '../models/ApplicationOverride';
export * from '../models/AppsCondition';
export * from '../models/AppsDetails';
export * from '../models/AtlasProject';
export * from '../models/AtlasProjects';
export * from '../models/AuditLog';
export * from '../models/AuditLogAction';
export * from '../models/AuditLogEntitiesInner';
export * from '../models/AuditLogFilterConditions';
export * from '../models/AuthResponse';
export * from '../models/AwsAccountConfigInput';
export * from '../models/AwsAccountMetricsDestination';
export * from '../models/AwsDatabaseDestination';
export * from '../models/AwsDynamoDBDestination';
export * from '../models/AwsDynamoDbResource';
export * from '../models/AwsDynamoDbSnapshotProperties';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput';
export * from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput';
export * from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner';
export * from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner';
export * from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection';
export * from '../models/AwsEbsSnapshotConvertResult';
export * from '../models/AwsEbsVolumeResource';
export * from '../models/AwsEbsVolumeRestoreData';
export * from '../models/AwsEbsVolumeRestoreResult';
export * from '../models/AwsEbsVolumeSnapshotProperties';
export * from '../models/AwsEc2AmiConvertResult';
export * from '../models/AwsEc2InstanceRestoreDestination';
export * from '../models/AwsEc2InstanceRestoreResult';
export * from '../models/AwsEc2InstanceRestoreTarget';
export * from '../models/AwsEc2Resource';
export * from '../models/AwsEc2SnapshotProperties';
export * from '../models/AwsEksNamespaceResource';
export * from '../models/AwsEksNamespaceSnapshotProperties';
export * from '../models/AwsFsxResource';
export * from '../models/AwsKeyspacesResource';
export * from '../models/AwsNativePitrBackupPolicyPlan';
export * from '../models/AwsNativePitrBackupResourceType';
export * from '../models/AwsNativePitrConfig';
export * from '../models/AwsRdsEngine';
export * from '../models/AwsRdsResource';
export * from '../models/AwsRdsResourceAurora';
export * from '../models/AwsRdsResourceStorageSettings';
export * from '../models/AwsRestoreAccountAttributes';
export * from '../models/AwsRestoreAccountAttributesInput';
export * from '../models/AwsRestoreAccountConnectivityConfig';
export * from '../models/AwsSourceAccountAttributes';
export * from '../models/AwsSourceAccountAttributesInput';
export * from '../models/AwsVaultConfig';
export * from '../models/AwsVaultConfigInput';
export * from '../models/AwsVpcConnectivityConfig';
export * from '../models/AzureAccountConfigInput';
export * from '../models/AzureAksNamespaceResource';
export * from '../models/AzureBackupApplicationsResponse';
export * from '../models/AzureConsentUrlResponse';
export * from '../models/AzureDisk';
export * from '../models/AzureDiskRestoreData';
export * from '../models/AzureDiskRestoreDestination';
export * from '../models/AzureDiskRestoreResult';
export * from '../models/AzureDiskSettings';
export * from '../models/AzureDiskTarget';
export * from '../models/AzureEonApplication';
export * from '../models/AzureListResourceGroupsResponse';
export * from '../models/AzureListSubscriptionsResponse';
export * from '../models/AzureManagementGroup';
export * from '../models/AzureManagementGroups';
export * from '../models/AzureMarketplaceWebhookInput';
export * from '../models/AzureMarketplaceWebhookInputSubscription';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionBeneficiary';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionPurchaser';
export * from '../models/AzureMarketplaceWebhookInputSubscriptionTerm';
export * from '../models/AzureMssqlSnapshotProperties';
export * from '../models/AzureOnboardedTenantsResponse';
export * from '../models/AzureOnboardingStatus';
export * from '../models/AzureResourceGroup';
export * from '../models/AzureResourceGroups';
export * from '../models/AzureRestoreAccountAttributes';
export * from '../models/AzureRestoreAccountAttributesInput';
export * from '../models/AzureRestorePointData';
export * from '../models/AzureRestorePointSpec';
export * from '../models/AzureSapHanaResource';
export * from '../models/AzureScanningAccountSetupStatus200Response';
export * from '../models/AzureSourceAccountAttributes';
export * from '../models/AzureSourceAccountAttributesInput';
export * from '../models/AzureSqlDatabaseRestoreDestination';
export * from '../models/AzureSqlDatabaseRestoreTarget';
export * from '../models/AzureStorageAccount';
export * from '../models/AzureStorageAccounts';
export * from '../models/AzureSubscription';
export * from '../models/AzureTenant';
export * from '../models/AzureVaultConfig';
export * from '../models/AzureVaultConfigInput';
export * from '../models/AzureVaultType';
export * from '../models/AzureVmInstanceRestoreDestination';
export * from '../models/AzureVmInstanceRestoreResult';
export * from '../models/AzureVmInstanceRestoreTarget';
export * from '../models/AzureVmSnapshotProperties';
export * from '../models/BackedUpByResourceType';
export * from '../models/BackedUpByResourceTypeDataInner';
export * from '../models/BackedUpStorageDateHistogram';
export * from '../models/BackupControlViolations';
export * from '../models/BackupJob';
export * from '../models/BackupJobResponse';
export * from '../models/BackupJobSortField';
export * from '../models/BackupJobType';
export * from '../models/BackupJobTypeFilters';
export * from '../models/BackupJobsFilterConditions';
export * from '../models/BackupPoliciesFilters';
export * from '../models/BackupPoliciesSecurityConfig';
export * from '../models/BackupPolicy';
export * from '../models/BackupPolicyAppliesNotificationArguments';
export * from '../models/BackupPolicyConfig';
export * from '../models/BackupPolicyExpression';
export * from '../models/BackupPolicyGroupCondition';
export * from '../models/BackupPolicyNotificationArguments';
export * from '../models/BackupPolicyPlan';
export * from '../models/BackupPolicyResourceSelector';
export * from '../models/BackupPolicySecurityConfig';
export * from '../models/BackupPolicyType';
export * from '../models/BackupRegionsFilters';
export * from '../models/BackupSchedule';
export * from '../models/BackupScope';
export * from '../models/BackupScopeSummary';
export * from '../models/BackupStatus';
export * from '../models/BackupStatusFilters';
export * from '../models/BackupVault';
export * from '../models/BatchApplicationOverrides';
export * from '../models/BatchOperationResponse';
export * from '../models/BatchResourceValidationResult';
export * from '../models/BatchUpdateLlgPoliciesRequest';
export * from '../models/BatchUpdateLlgPolicyItem';
export * from '../models/BatchValidateResourceConfigurationRequest';
export * from '../models/BatchValidateResourceConfigurationResponse';
export * from '../models/BigQueryDatasetDestination';
export * from '../models/BigQueryIntegrationConfig';
export * from '../models/BillingPeriod';
export * from '../models/BillingTransactionHistory';
export * from '../models/BooleanFilters';
export * from '../models/CancelExclusionFromBackupResponse';
export * from '../models/CatalogOperationRequest';
export * from '../models/CatalogOperationResponse';
export * from '../models/CheckAzureVMNameExists200Response';
export * from '../models/CheckAzureVMNameExistsRequest';
export * from '../models/Classifications';
export * from '../models/CloudAccountIdFilters';
export * from '../models/CloudAccountNotificationArguments';
export * from '../models/CloudAccountType';
export * from '../models/CloudProviderCondition';
export * from '../models/CloudProviderFilters';
export * from '../models/CloudRegion';
export * from '../models/CloudResourceAttachmentEvent';
export * from '../models/CloudResourceAttachmentEventType';
export * from '../models/CloudResourceConfiguration';
export * from '../models/CloudResourceConfigurationCdcBackup';
export * from '../models/CloudResourceConfigurationInventoryBackup';
export * from '../models/CloudResourceSecurityProperties';
export * from '../models/CloudSnapshotsPerVolume';
export * from '../models/ClusterNameFilters';
export * from '../models/ColumnMetadata';
export * from '../models/Condition';
export * from '../models/ConditionOperatorEnum';
export * from '../models/ConnectAzureBackupAccountRequest';
export * from '../models/ConnectAzureBackupApplicationsRequest';
export * from '../models/ConnectAzureRestoreAccountRequest';
export * from '../models/ConnectAzureSourceAccountRequest';
export * from '../models/ConnectAzureVaultAccountRequest';
export * from '../models/ConnectBYOAzureBackupApplicationsRequest';
export * from '../models/ConnectCustomerVaultAccountRequest';
export * from '../models/ConnectCustomerVaultAccountResponse';
export * from '../models/ConnectGcpFolderRequest';
export * from '../models/ConnectGcpFolderResponse';
export * from '../models/ConnectGcpOrganizationRequest';
export * from '../models/ConnectGcpOrganizationResponse';
export * from '../models/ConnectRestoreAccountRequest';
export * from '../models/ConnectRestoreAccountResponse';
export * from '../models/ConnectSourceAccountRequest';
export * from '../models/ConnectSourceAccountResponse';
export * from '../models/ConnectSourceAwsOrganizationalUnitRequest';
export * from '../models/ConnectSourceAwsOrganizationalUnitResponse';
export * from '../models/Control';
export * from '../models/ControlRules';
export * from '../models/ControlViolation';
export * from '../models/ControlViolations';
export * from '../models/ControlViolationsPerSeverity';
export * from '../models/ControlViolationsPerSeverityViolatedControlsInner';
export * from '../models/ControlsFilters';
export * from '../models/ConvertEbsSnapshotConfig';
export * from '../models/ConvertEc2ImageConfig';
export * from '../models/ConvertOtherSnapshotsOnDemandRequest';
export * from '../models/ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner';
export * from '../models/ConvertResourceSnapshotsRequest';
export * from '../models/ConvertResourceSnapshotsResponse';
export * from '../models/Cost';
export * from '../models/CostDataFilters';
export * from '../models/CostDataGroupBy';
export * from '../models/CostDataRecord';
export * from '../models/CostDataRecordCost';
export * from '../models/CostDataRecordDimensions';
export * from '../models/CostGranularity';
export * from '../models/CostRecordMetadata';
export * from '../models/CostRecordMetadataDataTransfer';
export * from '../models/CostRecordMetadataType';
export * from '../models/CostUnit';
export * from '../models/CreateAccountInput';
export * from '../models/CreateApiCredentialsRequest';
export * from '../models/CreateApiCredentialsResponse';
export * from '../models/CreateBackupPolicyRequest';
export * from '../models/CreateBackupPolicyResponse';
export * from '../models/CreateDashboardInput';
export * from '../models/CreateDlsgPolicyRequest';
export * from '../models/CreateDlsgPolicyResponse';
export * from '../models/CreateFabricTableShortcutDemoRequest';
export * from '../models/CreateFabricTableShortcutDemoRequestShortcutsInner';
export * from '../models/CreateFabricTableShortcutDemoResponse';
export * from '../models/CreateFabricTableShortcutDemoResponseResultsInner';
export * from '../models/CreateGraphInput';
export * from '../models/CreateIdpGroupRequest';
export * from '../models/CreateIdpGroupResponse';
export * from '../models/CreateInfectedExcludePathInput';
export * from '../models/CreateIngestionPipelineInput';
export * from '../models/CreateIntegrationRequest';
export * from '../models/CreateIntegrationResponse';
export * from '../models/CreateJobTemplateInput';
export * from '../models/CreateNotebookInput';
export * from '../models/CreatePolicyInput';
export * from '../models/CreatePolicyScheduleInput';
export * from '../models/CreateProjectInput';
export * from '../models/CreatePulumiConfigurationRequest';
export * from '../models/CreateRoleRequest';
export * from '../models/CreateRoleResponse';
export * from '../models/CreateSamlIdentityProviderConfigInput';
export * from '../models/CreateSavedQueryInput';
export * from '../models/CreateScanJobInput';
export * from '../models/CreateScanJobResponse';
export * from '../models/CreateSessionRequest';
export * from '../models/CreateSparkEngineInput';
export * from '../models/CreateSqlEngineInput';
export * from '../models/CreateUserInput';
export * from '../models/CreateVaultRequest';
export * from '../models/CreateVaultResponse';
export * from '../models/CrossResourceQueryRequest';
export * from '../models/CrossResourceQueryRequestResourcesInner';
export * from '../models/CustomTagsInner';
export * from '../models/CustomerVaultAccount';
export * from '../models/DBResourceMetadata';
export * from '../models/DBServerRecord';
export * from '../models/DBSnapshotMetadata';
export * from '../models/DBSnapshotType';
export * from '../models/DailyConfig';
export * from '../models/DailySnapshotData';
export * from '../models/DailyStorageSummaries';
export * from '../models/DailyStorageSummary';
export * from '../models/Dashboard';
export * from '../models/DashboardGraph';
export * from '../models/DashboardGraphLayout';
export * from '../models/DashboardWithGraphs';
export * from '../models/DataClass';
export * from '../models/DataClassesCondition';
export * from '../models/DataClassesDetails';
export * from '../models/DataClassesFilters';
export * from '../models/DataClassificationEntity';
export * from '../models/DataShareIntegrationConfig';
export * from '../models/DataTransferOperationType';
export * from '../models/DatabaseDestination';
export * from '../models/DatabaseRecord';
export * from '../models/DatabricksIntegrationConfig';
export * from '../models/DayOfWeek';
export * from '../models/DeactivateAccountRequest';
export * from '../models/DeactivateAccountResponse';
export * from '../models/DeactivateGcpFolderResponse';
export * from '../models/DeactivateGcpOrganizationResponse';
export * from '../models/DestinationDetails';
export * from '../models/DestinationProviderAttributes';
export * from '../models/DestinationProviderAttributesAzure';
export * from '../models/DestinationRestoreTypeAttributes';
export * from '../models/DisableResourceOverrideLimitsResponse';
export * from '../models/DisconnectCustomerVaultAccountResponse';
export * from '../models/DisconnectRestoreAccountResponse';
export * from '../models/DisconnectSourceAccountResponse';
export * from '../models/DisconnectSourceAwsOrganizationalUnitResponse';
export * from '../models/DiscoveryInvokeParams';
export * from '../models/DiscoveryJob';
export * from '../models/DiscoveryStatusResponse';
export * from '../models/DlsgPolicy';
export * from '../models/DlsgPolicyConfig';
export * from '../models/DlsgPolicyFilters';
export * from '../models/DlsgPolicyPlan';
export * from '../models/DlsgSettings';
export * from '../models/DriftProtectionPolicy';
export * from '../models/DriftProtectionSummary';
export * from '../models/DriftProtectionTimePoint';
export * from '../models/DynamoDBAdvancedIndexConfig';
export * from '../models/DynamoDBRestoreMethodAvailabilityRequest';
export * from '../models/DynamoDBRestoreMethodAvailabilityResponse';
export * from '../models/DynamoDbBackupConfig';
export * from '../models/DynamoDbBackupConfigApplication';
export * from '../models/DynamoDbBillingMode';
export * from '../models/DynamodbTableRestoreDestination';
export * from '../models/EFSRestoreDestination';
export * from '../models/EbsRestoreDestination';
export * from '../models/EbsSnapshotRestoreDestination';
export * from '../models/EbsSnapshotTarget';
export * from '../models/EbsTarget';
export * from '../models/EfsSnapshotProperties';
export * from '../models/EksCluster';
export * from '../models/EksClusterStatus';
export * from '../models/EksNamespaceRestoreDestination';
export * from '../models/EksNamespaceRestoreResult';
export * from '../models/EksVolumeRestoreResult';
export * from '../models/EmrIntegrationConfig';
export * from '../models/EnableFromLimitExceededResponse';
export * from '../models/EnableResourceOverrideLimitsResponse';
export * from '../models/EnableRestoreAccountMetricsConfigRequest';
export * from '../models/EnableRestoreAccountMetricsConfigResponse';
export * from '../models/EnableSourceAccountMetricsConfigRequest';
export * from '../models/EnableSourceAccountMetricsConfigResponse';
export * from '../models/EncryptionKey';
export * from '../models/EncryptionKeys';
export * from '../models/EndTimeDateFilters';
export * from '../models/Environment';
export * from '../models/EnvironmentCondition';
export * from '../models/EnvironmentDetails';
export * from '../models/EnvironmentFilters';
export * from '../models/EonAccount';
export * from '../models/EonAccountIdFilters';
export * from '../models/EonAccountStatus';
export * from '../models/ErrorCode';
export * from '../models/ExcludeFromBackupResponse';
export * from '../models/ExecuteNotebookCodeInput';
export * from '../models/ExportCostData400Response';
export * from '../models/ExportCostDataRequest';
export * from '../models/FSxRestoreDestination';
export * from '../models/FSxRestoreDestinationOntapRestoreOptions';
export * from '../models/FileExplorerCountSecurityAlertsInResourceResponse';
export * from '../models/FileExplorerResponse';
export * from '../models/FilePath';
export * from '../models/FileRestoreData';
export * from '../models/FileSearchRecord';
export * from '../models/FileSnapshot';
export * from '../models/ForceDeleteSnapshotsRequest';
export * from '../models/FreeTextFilters';
export * from '../models/FsxBackupData';
export * from '../models/FsxOntapVolume';
export * from '../models/FsxSnapshotProperties';
export * from '../models/FsxVolumeBackupInfo';
export * from '../models/GCSBucket';
export * from '../models/GCSBuckets';
export * from '../models/GCSRestoreDestination';
export * from '../models/GCSRestoreTarget';
export * from '../models/GcpAccountConfigInput';
export * from '../models/GcpBigQueryResource';
export * from '../models/GcpBigQueryResourceMaterializedViewsInner';
export * from '../models/GcpBigQueryResourceRoutinesInner';
export * from '../models/GcpBigQueryResourceTablesInner';
export * from '../models/GcpBigQueryResourceViewsInner';
export * from '../models/GcpCloudSqlResource';
export * from '../models/GcpCloudSqlResourceStorageSettings';
export * from '../models/GcpCloudSqlRestoreDestination';
export * from '../models/GcpCloudSqlSnapshotProperties';
export * from '../models/GcpCloudSqlTarget';
export * from '../models/GcpDiskResource';
export * from '../models/GcpDiskRestoreData';
export * from '../models/GcpDiskRestoreDestination';
export * from '../models/GcpDiskSettings';
export * from '../models/GcpDiskSnapshotProperties';
export * from '../models/GcpDiskTarget';
export * from '../models/GcpDiskTypesResponse';
export * from '../models/GcpEncryptionKey';
export * from '../models/GcpEncryptionKeys';
export * from '../models/GcpGkeNamespaceResource';
export * from '../models/GcpMachineTypesResponse';
export * from '../models/GcpNetworkConnectivityConfig';
export * from '../models/GcpNetworkType';
export * from '../models/GcpOrganization';
export * from '../models/GcpRestoreAccountAttributes';
export * from '../models/GcpRestoreAccountAttributesInput';
export * from '../models/GcpRestoreAccountConnectivityConfig';
export * from '../models/GcpSourceAccountAttributes';
export * from '../models/GcpSourceAccountAttributesInput';
export * from '../models/GcpSubnet';
export * from '../models/GcpSubnetPerRegion';
export * from '../models/GcpVaultConfig';
export * from '../models/GcpVaultConfigInput';
export * from '../models/GcpVmInstanceRestoreDestination';
export * from '../models/GcpVmInstanceRestoreTarget';
export * from '../models/GcpVmResource';
export * from '../models/GcpVmSnapshotProperties';
export * from '../models/GenericSnapshotData';
export * from '../models/GetAWSStackDetailsResponse';
export * from '../models/GetBackupJobResponse';
export * from '../models/GetBackupPolicyResponse';
export * from '../models/GetBillingPeriodsResponse';
export * from '../models/GetBillingTransactionHistoryRequest';
export * from '../models/GetBillingTransactionHistoryResponse';
export * from '../models/GetCloudResourceSecurityPropertiesResponse';
export * from '../models/GetCredits400Response';
export * from '../models/GetCreditsResponse';
export * from '../models/GetDlsgPolicyResponse';
export * from '../models/GetGcsServiceAgentResponse';
export * from '../models/GetIdpGroupResponse';
export * from '../models/GetIntegrationResponse';
export * from '../models/GetLimitsResponseValue';
export * from '../models/GetNotebookContent200Response';
export * from '../models/GetProjectConfigurationKeyResponse';
export * from '../models/GetProjectConfigurationKeysResponse';
export * from '../models/GetResourceResponse';
export * from '../models/GetRestoreAccountConnectivityConfigResponse';
export * from '../models/GetRestoreAccountMetricsConfigResponse';
export * from '../models/GetRestoreJobResponse';
export * from '../models/GetRoleResponse';
export * from '../models/GetScanJobResponse';
export * from '../models/GetSnapshotResponse';
export * from '../models/GetSourceAccountMetricsConfigResponse';
export * from '../models/GetSqlVmNetworkInfoRequest';
export * from '../models/GetSqlVmNetworkInfoResponse';
export * from '../models/GetVaultResponse';
export * from '../models/GroupToRoleMapping';
export * from '../models/HighFrequencyBackupPolicyPlan';
export * from '../models/HighFrequencyBackupResourceType';
export * from '../models/HighFrequencyBackupScheduleConfig';
export * from '../models/HighFrequencyBackupScheduleFrequency';
export * from '../models/HighFrequencyBackupSchedules';
export * from '../models/HighFrequencyIntervalConfig';
export * from '../models/IDs';
export * from '../models/IdFilters';
export * from '../models/Identifier';
export * from '../models/IdentityProvidersNames';
export * from '../models/Idp';
export * from '../models/IdpGroup';
export * from '../models/ImportDlsgCertificateRequest';
export * from '../models/IndexRestoreMode';
export * from '../models/InfectedDataByClassification';
export * from '../models/InfectedDataClassificationSize';
export * from '../models/InfectedDataOverTime';
export * from '../models/InfectedDateSize';
export * from '../models/InfectedExcludePath';
export * from '../models/InfectedResourcesCountResponse';
export * from '../models/IngestionPipeline';
export * from '../models/IngestionPipelineStatus';
export * from '../models/IngestionSourceType';
export * from '../models/InitAuthInput';
export * from '../models/Initiator';
export * from '../models/InitiatorNameFilters';
export * from '../models/IntegConfig';
export * from '../models/IntegType';
export * from '../models/IntegrationConfig';
export * from '../models/InventoryFilterConditions';
export * from '../models/InventoryGcpDisk';
export * from '../models/InventoryResource';
export * from '../models/InventoryResourceMetadata';
export * from '../models/InventorySnapshotVolume';
export * from '../models/InventoryVault';
export * from '../models/InventoryVolume';
export * from '../models/IssueMutedNotificationArguments';
export * from '../models/JobExecutionDetails';
export * from '../models/JobFailedNotificationArguments';
export * from '../models/JobIdFilters';
export * from '../models/JobInitiationResponse';
export * from '../models/JobMetricsReportFailedArguments';
export * from '../models/JobSnapshotDetails';
export * from '../models/JobStatus';
export * from '../models/JobStatusFilters';
export * from '../models/JobStep';
export * from '../models/JobStepName';
export * from '../models/JobStepStatus';
export * from '../models/JobSucceededNotificationArguments';
export * from '../models/JobTemplate';
export * from '../models/KubeAccessStatus';
export * from '../models/KubernetesAccessMode';
export * from '../models/LimitData';
export * from '../models/ListAccountsResponse';
export * from '../models/ListApiCredentialsResponse';
export * from '../models/ListApplicationOverrideResponse';
export * from '../models/ListAuditLogRequest';
export * from '../models/ListAuditLogResponse';
export * from '../models/ListAuditLogsResponse';
export * from '../models/ListAzureRegions200Response';
export * from '../models/ListAzureSKUs200Response';
export * from '../models/ListAzureSKUs200ResponseSkusInner';
export * from '../models/ListAzureSKUsRequest';
export * from '../models/ListAzureStorageAccountContainers200Response';
export * from '../models/ListAzureStorageAccountContainersRequest';
export * from '../models/ListAzureSubnets200Response';
export * from '../models/ListAzureSubnets200ResponseSubnetsInner';
export * from '../models/ListAzureSubnetsRequest';
export * from '../models/ListAzureUnassignedNetworkInterfaces200Response';
export * from '../models/ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner';
export * from '../models/ListAzureUnassignedNetworkInterfacesRequest';
export * from '../models/ListAzureVirtualNetworks200Response';
export * from '../models/ListAzureVirtualNetworks200ResponseVirtualNetworksInner';
export * from '../models/ListAzureVirtualNetworksRequest';
export * from '../models/ListBackupJobTypesResponse';
export * from '../models/ListBackupJobsInternal200Response';
export * from '../models/ListBackupJobsRequest';
export * from '../models/ListBackupJobsResponse';
export * from '../models/ListBackupPoliciesResponse';
export * from '../models/ListBackupPolicyResponse';
export * from '../models/ListBackupVaultResponse';
export * from '../models/ListCloudSnapshotsResponse';
export * from '../models/ListControlViolationsResponse';
export * from '../models/ListControlsResponse';
export * from '../models/ListDailySnapshotsResponse';
export * from '../models/ListDashboardsResponse';
export * from '../models/ListDataClassificationEntitiesResponse';
export * from '../models/ListDatabaseSnapshotsResponse';
export * from '../models/ListDlsgPoliciesResponse';
export * from '../models/ListDynamoDbBackupConfigsResponse';
export * from '../models/ListEksClustersResponse';
export * from '../models/ListGcpFoldersResponse';
export * from '../models/ListGcpNetworksResponse';
export * from '../models/ListGcpNetworksResponseNetworksInner';
export * from '../models/ListGcpOrganizationsResponse';
export * from '../models/ListGcpSubnetsResponse';
export * from '../models/ListIdpGroupsResponse';
export * from '../models/ListIdpsResponse';
export * from '../models/ListInfectedExcludePathsResponse';
export * from '../models/ListIngestionPipelinesResponse';
export * from '../models/ListInstanceProfilesResponse';
export * from '../models/ListInstanceTypesResponse';
export * from '../models/ListIntegrationsResponse';
export * from '../models/ListInventoryAppsResponse';
export * from '../models/ListInventoryBackupRegionsResponse';
export * from '../models/ListInventoryEnvironmentsResponse';
export * from '../models/ListInventoryGlobalDatabasesResponse';
export * from '../models/ListInventoryItemSnapshotsResponse';
export * from '../models/ListInventoryNetworksResponse';
export * from '../models/ListInventoryRequest';
export * from '../models/ListInventoryResourceGroupsResponse';
export * from '../models/ListInventoryResourceIdentifiersResponse';
export * from '../models/ListInventoryResourceTypesResponse';
export * from '../models/ListInventoryResourcesResponse';
export * from '../models/ListInventorySnapshotsRequest';
export * from '../models/ListInventorySnapshotsResponse';
export * from '../models/ListInventorySourceRegionsResponse';
export * from '../models/ListInventorySubnetsResponse';
export * from '../models/ListInventoryTagsResponse';
export * from '../models/ListJobErrorCodesResponse';
export * from '../models/ListJobTemplatesResponse';
export * from '../models/ListKnownAppsResponse';
export * from '../models/ListLogSourcesPoliciesResponse';
export * from '../models/ListLogSourcesResponse';
export * from '../models/ListNotebooksResponse';
export * from '../models/ListNotificationPoliciesResponse';
export * from '../models/ListNotificationsResponse';
export * from '../models/ListObjectStoreExclusionRulesResponse';
export * from '../models/ListOperators';
export * from '../models/ListPermissionsResponse';
export * from '../models/ListProjectsResponse';
export * from '../models/ListResourceAttachmentEventsResponse';
export * from '../models/ListResourcesResponse';
export * from '../models/ListRestoreAccountsRequest';
export * from '../models/ListRestoreAccountsResponse';
export * from '../models/ListRestoreJobTypesResponse';
export * from '../models/ListRestoreJobsInternal200Response';
export * from '../models/ListRestoreJobsRequest';
export * from '../models/ListRestoreJobsResponse';
export * from '../models/ListRolesResponse';
export * from '../models/ListSavedQueriesResponse';
export * from '../models/ListScanJobTypesResponse';
export * from '../models/ListScanJobsInternal200Response';
export * from '../models/ListScanJobsRequest';
export * from '../models/ListScanJobsResponse';
export * from '../models/ListSensitivityAnnotationsResponse';
export * from '../models/ListSourceAccountsRequest';
export * from '../models/ListSourceAccountsResponse';
export * from '../models/ListSourceAwsOrganizationalUnitsResponse';
export * from '../models/ListSparkEnginesResponse';
export * from '../models/ListSparkJobsResponse';
export * from '../models/ListSqlEnginesResponse';
export * from '../models/ListSqlQueryExecutionsResponse';
export * from '../models/ListStorageGatewaysResponse';
export * from '../models/ListSubnetsResponse';
export * from '../models/ListSubnetsResponseV2';
export * from '../models/ListSubnetsResponseV2SubnetsInner';
export * from '../models/ListUsersResponse';
export * from '../models/LlgLocationResource';
export * from '../models/LlgLocationWithResources';
export * from '../models/LlgResourcePolicy';
export * from '../models/LogRecord';
export * from '../models/LogSource';
export * from '../models/LogSourceLocation';
export * from '../models/LogSourceLocationCloudTrail';
export * from '../models/LogSourceLocationCloudWatchLogs';
export * from '../models/LogSourceLocationDatadog';
export * from '../models/LogSourceLocationSplunkDdss';
export * from '../models/LogSourceWithPolicy';
export * from '../models/LogicalOperator';
export * from '../models/LogsHistogramDataPoint';
export * from '../models/LogsSchema';
export * from '../models/LogsSchemaColumn';
export * from '../models/LogsSchemaEntry';
export * from '../models/LogsSchemasResponse';
export * from '../models/LuceneQueryInput';
export * from '../models/MaxRetentionRule';
export * from '../models/Message';
export * from '../models/MeteringDimension';
export * from '../models/MicrosoftFabricIntegrationConfig';
export * from '../models/MinRetentionRule';
export * from '../models/ModelError';
export * from '../models/MonthlyConfig';
export * from '../models/MonthlySnapshotData';
export * from '../models/MsaAcceptanceResponse';
export * from '../models/NativeStandardBackupPolicyPlan';
export * from '../models/NativeStandardBackupSchedules';
export * from '../models/NetworkInterfaceConfig';
export * from '../models/Notebook';
export * from '../models/NotebookExecutionOutput';
export * from '../models/NotebookExecutionResult';
export * from '../models/NotebookSession';
export * from '../models/NotebookSessionStatus';
export * from '../models/Notification';
export * from '../models/NotificationArguments';
export * from '../models/NotificationPolicy';
export * from '../models/NotificationPolicyConfig';
export * from '../models/NotificationPolicyConfigEmail';
export * from '../models/NotificationPolicyConfigServiceNow';
export * from '../models/NotificationPolicyConfigSlack';
export * from '../models/NotificationPolicyConfigSns';
export * from '../models/NotificationPolicyConfigSplunk';
export * from '../models/NotificationPolicyConfigWebhook';
export * from '../models/NotificationStatus';
export * from '../models/NotificationType';
export * from '../models/NumberOfCopiesRule';
export * from '../models/Oauth2TokenResponse';
export * from '../models/ObjectStorageDestination';
export * from '../models/ObjectStoreExclusionRule';
export * from '../models/OnboardingAzureResourceGroup';
export * from '../models/OperationIdFilters';
export * from '../models/OrganizationIdFilters';
export * from '../models/OverrideDataClassificationsRequest';
export * from '../models/OverrideDataClassificationsResponse';
export * from '../models/OverrideEnvironmentRequest';
export * from '../models/OverrideEnvironmentResponse';
export * from '../models/Pagination';
export * from '../models/PartialRestoreData';
export * from '../models/PartialRestoreType';
export * from '../models/Path';
export * from '../models/PathSnapshotsRequest';
export * from '../models/PathSnapshotsResponse';
export * from '../models/PathType';
export * from '../models/Permission';
export * from '../models/PermissionCategory';
export * from '../models/PermissionGrant';
export * from '../models/PermissionGrantInput';
export * from '../models/PermissionType';
export * from '../models/PersistentVolumeClaimProperties';
export * from '../models/PitrBackupPolicyPlan';
export * from '../models/PitrBackupResourceType';
export * from '../models/PitrBackupSchedules';
export * from '../models/PitrIntervalConfig';
export * from '../models/PitrRestoreVaultWindows';
export * from '../models/PitrRestoreWindow';
export * from '../models/PitrRestoreWindowsResponse';
export * from '../models/Preferences';
export * from '../models/Project';
export * from '../models/ProjectConfigurationKeyEnum';
export * from '../models/ProjectIdFilters';
export * from '../models/Provider';
export * from '../models/ProviderAccountIdFilters';
export * from '../models/ProviderOrganizationIdFilters';
export * from '../models/ProviderRestoreAccountConnectivityConfig';
export * from '../models/PulumiConfiguration';
export * from '../models/PulumiConfigurations';
export * from '../models/PulumiConfigurationsFilterConditions';
export * from '../models/PulumiConfigurationsRequest';
export * from '../models/QueryCostData400Response';
export * from '../models/QueryCostDataRequest';
export * from '../models/QueryCostDataResponse';
export * from '../models/QueryDBRequest';
export * from '../models/QueryDBResponse';
export * from '../models/QueryDBRestoreDestination';
export * from '../models/QueryDBRestoreDestinationType';
export * from '../models/QueryDBResultResponse';
export * from '../models/QueryDBStatus';
export * from '../models/QueryDBStatusResponse';
export * from '../models/QuotaStatus';
export * from '../models/QuotaStatusFilters';
export * from '../models/RansomwareResourceNotificationArguments';
export * from '../models/RansomwareSnapshotNotificationArguments';
export * from '../models/RdsNativePitrAdvancedConfig';
export * from '../models/RdsNativePitrClusterAdvancedConfig';
export * from '../models/RdsNativePitrNetworkConfig';
export * from '../models/RdsNativePitrWindow';
export * from '../models/ReactivateAccountRequest';
export * from '../models/ReconnectCustomerVaultAccountResponse';
export * from '../models/ReconnectRestoreAccountResponse';
export * from '../models/ReconnectSourceAccountResponse';
export * from '../models/ReconnectSourceAwsOrganizationalUnitResponse';
export * from '../models/RecordRestoreResult';
export * from '../models/RedshiftCluster';
export * from '../models/RedshiftClusters';
export * from '../models/RedshiftIntegrationConfig';
export * from '../models/RegionCondition';
export * from '../models/RegisterInput';
export * from '../models/RegisterInputBillingToken';
export * from '../models/RegisterResponse';
export * from '../models/RelatedGlobalDbCluster';
export * from '../models/RequestDetails';
export * from '../models/ResourceDetails';
export * from '../models/ResourceGroupNameCondition';
export * from '../models/ResourceIdCondition';
export * from '../models/ResourceIdFilters';
export * from '../models/ResourceIdentifiers';
export * from '../models/ResourceNameCondition';
export * from '../models/ResourceNameFilters';
export * from '../models/ResourceProperties';
export * from '../models/ResourceSelectorMode';
export * from '../models/ResourceSnapshot';
export * from '../models/ResourceSnapshotProperties';
export * from '../models/ResourceSortField';
export * from '../models/ResourceTag';
export * from '../models/ResourceType';
export * from '../models/ResourceTypeCondition';
export * from '../models/ResourceTypeFilters';
export * from '../models/ResourceTypeToSecurityGroup';
export * from '../models/ResourceValidationError';
export * from '../models/RestoreAccount';
export * from '../models/RestoreAccountAttributesInput';
export * from '../models/RestoreAccountCloudAttributes';
export * from '../models/RestoreAccountConnectivityConfig';
export * from '../models/RestoreAccountMetricsConfig';
export * from '../models/RestoreAccountRegions';
export * from '../models/RestoreAccountSortField';
export * from '../models/RestoreAccountsFilterConditions';
export * from '../models/RestoreAtlasClusterInput';
export * from '../models/RestoreAvailabilityZones';
export * from '../models/RestoreAwsEc2InstanceRequest';
export * from '../models/RestoreAzureDiskConfig';
export * from '../models/RestoreAzureDiskRequest';
export * from '../models/RestoreAzureInstanceDiskInput';
export * from '../models/RestoreAzureSqlDatabaseRequest';
export * from '../models/RestoreAzureSqlVmPitrRequest';
export * from '../models/RestoreAzureVMInstanceConfig';
export * from '../models/RestoreAzureVmInstanceRequest';
export * from '../models/RestoreBigQueryDatasetRequest';
export * from '../models/RestoreBucketRequest';
export * from '../models/RestoreDbToRdsInstanceRequest';
export * from '../models/RestoreDbToRdsSnapshotRequest';
export * from '../models/RestoreDynamoDBTableRequest';
export * from '../models/RestoreDynamoDBToExistingTableRequest';
export * from '../models/RestoreDynamoDbTableConfig';
export * from '../models/RestoreEFSRequest';
export * from '../models/RestoreEbsVolumeConfig';
export * from '../models/RestoreEc2InstanceConfig';
export * from '../models/RestoreEksNamespaceConfig';
export * from '../models/RestoreEksNamespaceInput';
export * from '../models/RestoreEksNamespaceVolumeInput';
export * from '../models/RestoreFSxRequest';
export * from '../models/RestoreFilesRequest';
export * from '../models/RestoreGceDiskConfig';
export * from '../models/RestoreGceInstanceConfig';
export * from '../models/RestoreGcpCloudSqlDatabaseConfig';
export * from '../models/RestoreGcpCloudSqlRequest';
export * from '../models/RestoreGcpDiskRequest';
export * from '../models/RestoreGcpInstanceDiskInput';
export * from '../models/RestoreGcpVmInstanceRequest';
export * from '../models/RestoreImageImageDeviceInput';
export * from '../models/RestoreImageImageInput';
export * from '../models/RestoreImageInput';
export * from '../models/RestoreImageVolumeInput';
export * from '../models/RestoreInstanceImageDeviceInput';
export * from '../models/RestoreInstanceImageInput';
export * from '../models/RestoreInstanceVolumeInput';
export * from '../models/RestoreJob';
export * from '../models/RestoreJobConfiguration';
export * from '../models/RestoreJobInitiationResponse';
export * from '../models/RestoreJobSortField';
export * from '../models/RestoreJobType';
export * from '../models/RestoreJobTypeFilters';
export * from '../models/RestoreJobsFilterConditions';
export * from '../models/RestoreMethod';
export * from '../models/RestoreMethodAvailabilityReason';
export * from '../models/RestoreRdsInstanceClasses';
export * from '../models/RestoreRdsInstanceConfig';
export * from '../models/RestoreRdsNativePitrRequest';
export * from '../models/RestoreRdsSubnetGroups';
export * from '../models/RestoreRdsSubnetGroupsRdsSubnetGroupsInner';
export * from '../models/RestoreResult';
export * from '../models/RestoreSecurityGroups';
export * from '../models/RestoreSecurityGroupsSecurityGroupsInner';
export * from '../models/RestoreVolumeToEbsRequest';
export * from '../models/RestoreVolumeToEbsSnapshotRequest';
export * from '../models/Role';
export * from '../models/RoleAccessGroupCondition';
export * from '../models/RoleInstallationMethod';
export * from '../models/S3Bucket';
export * from '../models/S3Buckets';
export * from '../models/S3RestoreDestination';
export * from '../models/S3RestoreTarget';
export * from '../models/S3SourceProperties';
export * from '../models/SAMLCallback400Response';
export * from '../models/SAMLCallback401Response';
export * from '../models/SAMLCallback500Response';
export * from '../models/SamlIdentityProvider';
export * from '../models/SamlIdentityProviderConfigsResponse';
export * from '../models/SapHanaInstance';
export * from '../models/SapHanaRestoreProperties';
export * from '../models/SaveCloudResourceSecurityPropertiesRequest';
export * from '../models/SaveNotebookContentRequest';
export * from '../models/SavedQuery';
export * from '../models/ScalarOperators';
export * from '../models/ScanJob';
export * from '../models/ScanJobType';
export * from '../models/ScheduleMode';
export * from '../models/ScheduleType';
export * from '../models/SchemaRecord';
export * from '../models/SearchDBResponse';
export * from '../models/SearchFilesResponse';
export * from '../models/SearchInput';
export * from '../models/SearchLogsHistogramInput';
export * from '../models/SearchLogsHistogramResponse';
export * from '../models/SearchLogsInput';
export * from '../models/SearchLogsResponse';
export * from '../models/SearchResources200Response';
export * from '../models/SearchResources200ResponseTablesInner';
export * from '../models/SearchResources200ResponseTablesInnerResource';
export * from '../models/SearchResources200ResponseTablesInnerSnapshots';
export * from '../models/SearchResources200ResponseTablesInnerSource';
export * from '../models/SearchResources200ResponseTablesInnerTablesInner';
export * from '../models/SearchResources200ResponseTablesInnerTablesInnerColumnsInner';
export * from '../models/SearchResourcesRequest';
export * from '../models/SecurityAssignmentStatus';
export * from '../models/SecurityInformation';
export * from '../models/SecurityPlan';
export * from '../models/SecurityPlanEnabledResponse';
export * from '../models/SecurityScan';
export * from '../models/SecurityScanExample';
export * from '../models/SecurityScanResult';
export * from '../models/SecurityScansSummaryResponse';
export * from '../models/SecuritySummary';
export * from '../models/SendMessageToAI400Response';
export * from '../models/SendMessageToAIRequest';
export * from '../models/SensitivityAnnotation';
export * from '../models/ServiceProviderDetails';
export * from '../models/Session';
export * from '../models/Severity';
export * from '../models/SeverityFilters';
export * from '../models/Snapshot';
export * from '../models/SnapshotDateFilters';
export * from '../models/SnapshotFilterConditions';
export * from '../models/SnapshotIdFilters';
export * from '../models/SnapshotLocation';
export * from '../models/SnapshotReference';
export * from '../models/SnapshotSortField';
export * from '../models/SnapshotStatus';
export * from '../models/SnapshotStorage';
export * from '../models/SnapshotsSummaryResponse';
export * from '../models/SnowflakeIntegrationConfig';
export * from '../models/SortBackupJobBy';
export * from '../models/SortLogsBy';
export * from '../models/SortOrder';
export * from '../models/SortResourceBy';
export * from '../models/SortRestoreAccountsBy';
export * from '../models/SortRestoreJobBy';
export * from '../models/SortSnapshotsBy';
export * from '../models/SortSourceAccountsBy';
export * from '../models/SourceAccount';
export * from '../models/SourceAccountAttributesInput';
export * from '../models/SourceAccountCloudAttributes';
export * from '../models/SourceAccountMetricsConfig';
export * from '../models/SourceAccountProviderIdFilters';
export * from '../models/SourceAccountSortField';
export * from '../models/SourceAccountsFilterConditions';
export * from '../models/SourceAwsOrganizationalUnit';
export * from '../models/SourceRegionFilters';
export * from '../models/SourceStorage';
export * from '../models/SourceStorageBackupStatus';
export * from '../models/SparkEngine';
export * from '../models/SparkEngineStatus';
export * from '../models/SparkJob';
export * from '../models/SparkJobRetryPolicy';
export * from '../models/SparkJobSparkSubmitParams';
export * from '../models/SparkJobStatus';
export * from '../models/SqlEngine';
export * from '../models/SqlEngineStatus';
export * from '../models/SqlQueryExecution';
export * from '../models/SqlQueryExecutionResult';
export * from '../models/SqlQueryExecutionResultColumn';
export * from '../models/SqlQueryExecutionStatus';
export * from '../models/SqlVmNetworkInfo';
export * from '../models/SsoIntegrationSettings';
export * from '../models/StackNameFilters';
export * from '../models/StandardBackupPolicyPlan';
export * from '../models/StandardBackupScheduleConfig';
export * from '../models/StandardBackupScheduleFrequency';
export * from '../models/StandardBackupSchedules';
export * from '../models/StandardIntervalConfig';
export * from '../models/StartNotebookSessionInput';
export * from '../models/StartSparkJobInput';
export * from '../models/StartSqlQueryExecutionInput';
export * from '../models/StartTimeDateFilters';
export * from '../models/StatusCodeFilters';
export * from '../models/StorageAccountContainerRestoreDestination';
export * from '../models/StorageAccountRestoreTarget';
export * from '../models/StorageGateway';
export * from '../models/StorageGatewayDetails';
export * from '../models/StorageGatewayStatus';
export * from '../models/SubnetConfig';
export * from '../models/SubnetFilters';
export * from '../models/SubnetPerAvailabilityZone';
export * from '../models/SubnetsCondition';
export * from '../models/SupportedProviders';
export * from '../models/TableRecord';
export * from '../models/TagKeyValue';
export * from '../models/TagKeyValuesCondition';
export * from '../models/TagKeyValuesFilters';
export * from '../models/TagKeysCondition';
export * from '../models/TagKeysFilters';
export * from '../models/TakeNativeSnapshotRequest';
export * from '../models/TakeSnapshotRequest';
export * from '../models/TakeSnapshotResponse';
export * from '../models/TimeFrame';
export * from '../models/TimeOfDay';
export * from '../models/TimeOfYear';
export * from '../models/TokenResponse';
export * from '../models/UnifiedDBRecord';
export * from '../models/UnifiedDBServerRecord';
export * from '../models/UnifiedDatabaseRecord';
export * from '../models/UnifiedSchemaRecord';
export * from '../models/UnifiedTableRecord';
export * from '../models/UpPulumiStacksResponse';
export * from '../models/UpdateApiCredentialsRequest';
export * from '../models/UpdateBackupPolicyRequest';
export * from '../models/UpdateBackupPolicyResponse';
export * from '../models/UpdateCloudResourceConfigurationRequest';
export * from '../models/UpdateCloudResourceConfigurationRequestCdcBackup';
export * from '../models/UpdateCloudResourceConfigurationRequestInventoryBackup';
export * from '../models/UpdateControlViolationInput';
export * from '../models/UpdateDashboardInput';
export * from '../models/UpdateDlsgPolicyRequest';
export * from '../models/UpdateDlsgPolicyResponse';
export * from '../models/UpdateGraphInput';
export * from '../models/UpdateIdpGroupRequest';
export * from '../models/UpdateIdpGroupResponse';
export * from '../models/UpdateIntegrationRequest';
export * from '../models/UpdateIntegrationResponse';
export * from '../models/UpdateJobTemplateInput';
export * from '../models/UpdateNotebookInput';
export * from '../models/UpdateProjectConfigurationKeyRequest';
export * from '../models/UpdatePulumiConfigurationRequest';
export * from '../models/UpdateResourceSecurityScansExclusionRequest';
export * from '../models/UpdateRestoreAccountConnectivityConfigRequest';
export * from '../models/UpdateRestoreAccountConnectivityConfigResponse';
export * from '../models/UpdateRoleRequest';
export * from '../models/UpdateRoleResponse';
export * from '../models/UpdateSamlIdentityProviderInput';
export * from '../models/UpdateSavedQueryInput';
export * from '../models/UpdateSessionRequest';
export * from '../models/UpdateShouldFullBackupResourceRequest';
export * from '../models/UpdateUserInput';
export * from '../models/UpdateVaultRequest';
export * from '../models/UpdateVaultResponse';
export * from '../models/UpdateViewerRoleRequest';
export * from '../models/Usage';
export * from '../models/UsageUnit';
export * from '../models/User';
export * from '../models/UserIdFilters';
export * from '../models/VNetConfig';
export * from '../models/ValidateResourceConfigurationRequest';
export * from '../models/ValidateResourceConfigurationResponse';
export * from '../models/VaultFilters';
export * from '../models/VaultMetadataReplicationConfig';
export * from '../models/VaultNotificationArguments';
export * from '../models/VaultProviderAttributes';
export * from '../models/VaultProviderAttributesInput';
export * from '../models/VaultSnapshotCount';
export * from '../models/Viewer';
export * from '../models/ViolationsDetectionNotificationArguments';
export * from '../models/VirtualMachineRestoreDestination';
export * from '../models/VisualizationHistogramSeries';
export * from '../models/VisualizationHistogramTimePoint';
export * from '../models/VisualizationLabel';
export * from '../models/VolumeSettings';
export * from '../models/VpcCondition';
export * from '../models/VpcPropertyFilters';
export * from '../models/WeeklyConfig';
export * from '../models/Workspace';
export * from '../models/WorkspaceStatus';
export * from '../models/YearlySnapshotDistribution';

import { AccessCondition } from '../models/AccessCondition';
import { AccessConditionEffect } from '../models/AccessConditionEffect';
import { AccessConditionalExpression } from '../models/AccessConditionalExpression';
import { Account } from '../models/Account';
import { AccountConfigInput } from '../models/AccountConfigInput';
import { AccountIdCondition } from '../models/AccountIdCondition';
import { AccountIdFilters } from '../models/AccountIdFilters';
import { AccountInstallationMethod } from '../models/AccountInstallationMethod';
import { AccountMetricsDestination } from '../models/AccountMetricsDestination';
import { AccountNameFilters } from '../models/AccountNameFilters';
import { AccountState } from '../models/AccountState';
import { AccountStatusFilters } from '../models/AccountStatusFilters';
import { AccountUpdateInput } from '../models/AccountUpdateInput';
import { AccountVersion } from '../models/AccountVersion';
import { ActionFilters } from '../models/ActionFilters';
import { ActionRequiredDetails } from '../models/ActionRequiredDetails';
import { ActivateGcpFolderResponse } from '../models/ActivateGcpFolderResponse';
import { ActivateGcpOrganizationResponse } from '../models/ActivateGcpOrganizationResponse';
import { Ami } from '../models/Ami';
import { AmiBlockDevice } from '../models/AmiBlockDevice';
import { AnnuallyConfig } from '../models/AnnuallyConfig';
import { ApiCredentials } from '../models/ApiCredentials';
import { ApiCredentialsProperties } from '../models/ApiCredentialsProperties';
import { App } from '../models/App';
import { AppFilters } from '../models/AppFilters';
import { ApplicationOverride } from '../models/ApplicationOverride';
import { AppsCondition } from '../models/AppsCondition';
import { AppsDetails } from '../models/AppsDetails';
import { AtlasProject } from '../models/AtlasProject';
import { AtlasProjects } from '../models/AtlasProjects';
import { AuditLog } from '../models/AuditLog';
import { AuditLogAction } from '../models/AuditLogAction';
import { AuditLogEntitiesInner } from '../models/AuditLogEntitiesInner';
import { AuditLogFilterConditions } from '../models/AuditLogFilterConditions';
import { AuthResponse } from '../models/AuthResponse';
import { AwsAccountConfigInput } from '../models/AwsAccountConfigInput';
import { AwsAccountMetricsDestination } from '../models/AwsAccountMetricsDestination';
import { AwsDatabaseDestination } from '../models/AwsDatabaseDestination';
import { AwsDynamoDBDestination } from '../models/AwsDynamoDBDestination';
import { AwsDynamoDbResource } from '../models/AwsDynamoDbResource';
import { AwsDynamoDbSnapshotProperties } from '../models/AwsDynamoDbSnapshotProperties';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput';
import { AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput } from '../models/AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner';
import { AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection } from '../models/AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection';
import { AwsEbsSnapshotConvertResult } from '../models/AwsEbsSnapshotConvertResult';
import { AwsEbsVolumeResource, AwsEbsVolumeResourceVolumeTypeEnum, AwsEbsVolumeResourceStateEnum } from '../models/AwsEbsVolumeResource';
import { AwsEbsVolumeRestoreData } from '../models/AwsEbsVolumeRestoreData';
import { AwsEbsVolumeRestoreResult } from '../models/AwsEbsVolumeRestoreResult';
import { AwsEbsVolumeSnapshotProperties } from '../models/AwsEbsVolumeSnapshotProperties';
import { AwsEc2AmiConvertResult } from '../models/AwsEc2AmiConvertResult';
import { AwsEc2InstanceRestoreDestination } from '../models/AwsEc2InstanceRestoreDestination';
import { AwsEc2InstanceRestoreResult } from '../models/AwsEc2InstanceRestoreResult';
import { AwsEc2InstanceRestoreTarget } from '../models/AwsEc2InstanceRestoreTarget';
import { AwsEc2Resource } from '../models/AwsEc2Resource';
import { AwsEc2SnapshotProperties } from '../models/AwsEc2SnapshotProperties';
import { AwsEksNamespaceResource } from '../models/AwsEksNamespaceResource';
import { AwsEksNamespaceSnapshotProperties } from '../models/AwsEksNamespaceSnapshotProperties';
import { AwsFsxResource, AwsFsxResourceFileSystemTypeEnum, AwsFsxResourceStorageTypeEnum, AwsFsxResourceLifecycleStatusEnum } from '../models/AwsFsxResource';
import { AwsKeyspacesResource, AwsKeyspacesResourceCdcStatusEnum, AwsKeyspacesResourceCdcViewTypeEnum } from '../models/AwsKeyspacesResource';
import { AwsNativePitrBackupPolicyPlan } from '../models/AwsNativePitrBackupPolicyPlan';
import { AwsNativePitrBackupResourceType } from '../models/AwsNativePitrBackupResourceType';
import { AwsNativePitrConfig } from '../models/AwsNativePitrConfig';
import { AwsRdsEngine } from '../models/AwsRdsEngine';
import { AwsRdsResource } from '../models/AwsRdsResource';
import { AwsRdsResourceAurora } from '../models/AwsRdsResourceAurora';
import { AwsRdsResourceStorageSettings } from '../models/AwsRdsResourceStorageSettings';
import { AwsRestoreAccountAttributes } from '../models/AwsRestoreAccountAttributes';
import { AwsRestoreAccountAttributesInput } from '../models/AwsRestoreAccountAttributesInput';
import { AwsRestoreAccountConnectivityConfig } from '../models/AwsRestoreAccountConnectivityConfig';
import { AwsSourceAccountAttributes } from '../models/AwsSourceAccountAttributes';
import { AwsSourceAccountAttributesInput } from '../models/AwsSourceAccountAttributesInput';
import { AwsVaultConfig } from '../models/AwsVaultConfig';
import { AwsVaultConfigInput } from '../models/AwsVaultConfigInput';
import { AwsVpcConnectivityConfig } from '../models/AwsVpcConnectivityConfig';
import { AzureAccountConfigInput } from '../models/AzureAccountConfigInput';
import { AzureAksNamespaceResource } from '../models/AzureAksNamespaceResource';
import { AzureBackupApplicationsResponse } from '../models/AzureBackupApplicationsResponse';
import { AzureConsentUrlResponse } from '../models/AzureConsentUrlResponse';
import { AzureDisk } from '../models/AzureDisk';
import { AzureDiskRestoreData } from '../models/AzureDiskRestoreData';
import { AzureDiskRestoreDestination } from '../models/AzureDiskRestoreDestination';
import { AzureDiskRestoreResult } from '../models/AzureDiskRestoreResult';
import { AzureDiskSettings } from '../models/AzureDiskSettings';
import { AzureDiskTarget } from '../models/AzureDiskTarget';
import { AzureEonApplication } from '../models/AzureEonApplication';
import { AzureListResourceGroupsResponse } from '../models/AzureListResourceGroupsResponse';
import { AzureListSubscriptionsResponse } from '../models/AzureListSubscriptionsResponse';
import { AzureManagementGroup } from '../models/AzureManagementGroup';
import { AzureManagementGroups } from '../models/AzureManagementGroups';
import { AzureMarketplaceWebhookInput, AzureMarketplaceWebhookInputActionEnum, AzureMarketplaceWebhookInputStatusEnum, AzureMarketplaceWebhookInputOperationRequestSourceEnum } from '../models/AzureMarketplaceWebhookInput';
import { AzureMarketplaceWebhookInputSubscription, AzureMarketplaceWebhookInputSubscriptionAllowedCustomerOperationsEnum, AzureMarketplaceWebhookInputSubscriptionSessionModeEnum, AzureMarketplaceWebhookInputSubscriptionSandboxTypeEnum, AzureMarketplaceWebhookInputSubscriptionSaasSubscriptionStatusEnum } from '../models/AzureMarketplaceWebhookInputSubscription';
import { AzureMarketplaceWebhookInputSubscriptionBeneficiary } from '../models/AzureMarketplaceWebhookInputSubscriptionBeneficiary';
import { AzureMarketplaceWebhookInputSubscriptionPurchaser } from '../models/AzureMarketplaceWebhookInputSubscriptionPurchaser';
import { AzureMarketplaceWebhookInputSubscriptionTerm, AzureMarketplaceWebhookInputSubscriptionTermTermUnitEnum } from '../models/AzureMarketplaceWebhookInputSubscriptionTerm';
import { AzureMssqlSnapshotProperties } from '../models/AzureMssqlSnapshotProperties';
import { AzureOnboardedTenantsResponse } from '../models/AzureOnboardedTenantsResponse';
import { AzureOnboardingStatus, AzureOnboardingStatusStatusEnum } from '../models/AzureOnboardingStatus';
import { AzureResourceGroup } from '../models/AzureResourceGroup';
import { AzureResourceGroups } from '../models/AzureResourceGroups';
import { AzureRestoreAccountAttributes } from '../models/AzureRestoreAccountAttributes';
import { AzureRestoreAccountAttributesInput } from '../models/AzureRestoreAccountAttributesInput';
import { AzureRestorePointData, AzureRestorePointDataRestorePointTypeEnum } from '../models/AzureRestorePointData';
import { AzureRestorePointSpec } from '../models/AzureRestorePointSpec';
import { AzureSapHanaResource } from '../models/AzureSapHanaResource';
import { AzureScanningAccountSetupStatus200Response } from '../models/AzureScanningAccountSetupStatus200Response';
import { AzureSourceAccountAttributes } from '../models/AzureSourceAccountAttributes';
import { AzureSourceAccountAttributesInput } from '../models/AzureSourceAccountAttributesInput';
import { AzureSqlDatabaseRestoreDestination } from '../models/AzureSqlDatabaseRestoreDestination';
import { AzureSqlDatabaseRestoreTarget } from '../models/AzureSqlDatabaseRestoreTarget';
import { AzureStorageAccount } from '../models/AzureStorageAccount';
import { AzureStorageAccounts } from '../models/AzureStorageAccounts';
import { AzureSubscription } from '../models/AzureSubscription';
import { AzureTenant } from '../models/AzureTenant';
import { AzureVaultConfig } from '../models/AzureVaultConfig';
import { AzureVaultConfigInput } from '../models/AzureVaultConfigInput';
import { AzureVaultType } from '../models/AzureVaultType';
import { AzureVmInstanceRestoreDestination } from '../models/AzureVmInstanceRestoreDestination';
import { AzureVmInstanceRestoreResult } from '../models/AzureVmInstanceRestoreResult';
import { AzureVmInstanceRestoreTarget } from '../models/AzureVmInstanceRestoreTarget';
import { AzureVmSnapshotProperties } from '../models/AzureVmSnapshotProperties';
import { BackedUpByResourceType } from '../models/BackedUpByResourceType';
import { BackedUpByResourceTypeDataInner } from '../models/BackedUpByResourceTypeDataInner';
import { BackedUpStorageDateHistogram } from '../models/BackedUpStorageDateHistogram';
import { BackupControlViolations } from '../models/BackupControlViolations';
import { BackupJob } from '../models/BackupJob';
import { BackupJobResponse } from '../models/BackupJobResponse';
import { BackupJobSortField } from '../models/BackupJobSortField';
import { BackupJobType } from '../models/BackupJobType';
import { BackupJobTypeFilters } from '../models/BackupJobTypeFilters';
import { BackupJobsFilterConditions } from '../models/BackupJobsFilterConditions';
import { BackupPoliciesFilters } from '../models/BackupPoliciesFilters';
import { BackupPoliciesSecurityConfig } from '../models/BackupPoliciesSecurityConfig';
import { BackupPolicy } from '../models/BackupPolicy';
import { BackupPolicyAppliesNotificationArguments } from '../models/BackupPolicyAppliesNotificationArguments';
import { BackupPolicyConfig } from '../models/BackupPolicyConfig';
import { BackupPolicyExpression } from '../models/BackupPolicyExpression';
import { BackupPolicyGroupCondition } from '../models/BackupPolicyGroupCondition';
import { BackupPolicyNotificationArguments } from '../models/BackupPolicyNotificationArguments';
import { BackupPolicyPlan } from '../models/BackupPolicyPlan';
import { BackupPolicyResourceSelector } from '../models/BackupPolicyResourceSelector';
import { BackupPolicySecurityConfig } from '../models/BackupPolicySecurityConfig';
import { BackupPolicyType } from '../models/BackupPolicyType';
import { BackupRegionsFilters } from '../models/BackupRegionsFilters';
import { BackupSchedule } from '../models/BackupSchedule';
import { BackupScope } from '../models/BackupScope';
import { BackupScopeSummary } from '../models/BackupScopeSummary';
import { BackupStatus } from '../models/BackupStatus';
import { BackupStatusFilters } from '../models/BackupStatusFilters';
import { BackupVault } from '../models/BackupVault';
import { BatchApplicationOverrides } from '../models/BatchApplicationOverrides';
import { BatchOperationResponse } from '../models/BatchOperationResponse';
import { BatchResourceValidationResult } from '../models/BatchResourceValidationResult';
import { BatchUpdateLlgPoliciesRequest } from '../models/BatchUpdateLlgPoliciesRequest';
import { BatchUpdateLlgPolicyItem } from '../models/BatchUpdateLlgPolicyItem';
import { BatchValidateResourceConfigurationRequest } from '../models/BatchValidateResourceConfigurationRequest';
import { BatchValidateResourceConfigurationResponse } from '../models/BatchValidateResourceConfigurationResponse';
import { BigQueryDatasetDestination } from '../models/BigQueryDatasetDestination';
import { BigQueryIntegrationConfig } from '../models/BigQueryIntegrationConfig';
import { BillingPeriod } from '../models/BillingPeriod';
import { BillingTransactionHistory, BillingTransactionHistoryTransactionTypeEnum } from '../models/BillingTransactionHistory';
import { BooleanFilters } from '../models/BooleanFilters';
import { CancelExclusionFromBackupResponse } from '../models/CancelExclusionFromBackupResponse';
import { CatalogOperationRequest, CatalogOperationRequestCatalogNameEnum, CatalogOperationRequestMethodEnum } from '../models/CatalogOperationRequest';
import { CatalogOperationResponse } from '../models/CatalogOperationResponse';
import { CheckAzureVMNameExists200Response } from '../models/CheckAzureVMNameExists200Response';
import { CheckAzureVMNameExistsRequest } from '../models/CheckAzureVMNameExistsRequest';
import { Classifications } from '../models/Classifications';
import { CloudAccountIdFilters } from '../models/CloudAccountIdFilters';
import { CloudAccountNotificationArguments } from '../models/CloudAccountNotificationArguments';
import { CloudAccountType } from '../models/CloudAccountType';
import { CloudProviderCondition } from '../models/CloudProviderCondition';
import { CloudProviderFilters } from '../models/CloudProviderFilters';
import { CloudRegion } from '../models/CloudRegion';
import { CloudResourceAttachmentEvent } from '../models/CloudResourceAttachmentEvent';
import { CloudResourceAttachmentEventType } from '../models/CloudResourceAttachmentEventType';
import { CloudResourceConfiguration } from '../models/CloudResourceConfiguration';
import { CloudResourceConfigurationCdcBackup } from '../models/CloudResourceConfigurationCdcBackup';
import { CloudResourceConfigurationInventoryBackup } from '../models/CloudResourceConfigurationInventoryBackup';
import { CloudResourceSecurityProperties } from '../models/CloudResourceSecurityProperties';
import { CloudSnapshotsPerVolume } from '../models/CloudSnapshotsPerVolume';
import { ClusterNameFilters } from '../models/ClusterNameFilters';
import { ColumnMetadata } from '../models/ColumnMetadata';
import { Condition } from '../models/Condition';
import { ConditionOperatorEnum } from '../models/ConditionOperatorEnum';
import { ConnectAzureBackupAccountRequest } from '../models/ConnectAzureBackupAccountRequest';
import { ConnectAzureBackupApplicationsRequest } from '../models/ConnectAzureBackupApplicationsRequest';
import { ConnectAzureRestoreAccountRequest } from '../models/ConnectAzureRestoreAccountRequest';
import { ConnectAzureSourceAccountRequest } from '../models/ConnectAzureSourceAccountRequest';
import { ConnectAzureVaultAccountRequest } from '../models/ConnectAzureVaultAccountRequest';
import { ConnectBYOAzureBackupApplicationsRequest } from '../models/ConnectBYOAzureBackupApplicationsRequest';
import { ConnectCustomerVaultAccountRequest } from '../models/ConnectCustomerVaultAccountRequest';
import { ConnectCustomerVaultAccountResponse } from '../models/ConnectCustomerVaultAccountResponse';
import { ConnectGcpFolderRequest } from '../models/ConnectGcpFolderRequest';
import { ConnectGcpFolderResponse } from '../models/ConnectGcpFolderResponse';
import { ConnectGcpOrganizationRequest } from '../models/ConnectGcpOrganizationRequest';
import { ConnectGcpOrganizationResponse } from '../models/ConnectGcpOrganizationResponse';
import { ConnectRestoreAccountRequest } from '../models/ConnectRestoreAccountRequest';
import { ConnectRestoreAccountResponse } from '../models/ConnectRestoreAccountResponse';
import { ConnectSourceAccountRequest } from '../models/ConnectSourceAccountRequest';
import { ConnectSourceAccountResponse } from '../models/ConnectSourceAccountResponse';
import { ConnectSourceAwsOrganizationalUnitRequest } from '../models/ConnectSourceAwsOrganizationalUnitRequest';
import { ConnectSourceAwsOrganizationalUnitResponse } from '../models/ConnectSourceAwsOrganizationalUnitResponse';
import { Control } from '../models/Control';
import { ControlRules } from '../models/ControlRules';
import { ControlViolation } from '../models/ControlViolation';
import { ControlViolations } from '../models/ControlViolations';
import { ControlViolationsPerSeverity } from '../models/ControlViolationsPerSeverity';
import { ControlViolationsPerSeverityViolatedControlsInner } from '../models/ControlViolationsPerSeverityViolatedControlsInner';
import { ControlsFilters } from '../models/ControlsFilters';
import { ConvertEbsSnapshotConfig } from '../models/ConvertEbsSnapshotConfig';
import { ConvertEc2ImageConfig } from '../models/ConvertEc2ImageConfig';
import { ConvertOtherSnapshotsOnDemandRequest } from '../models/ConvertOtherSnapshotsOnDemandRequest';
import { ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner } from '../models/ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner';
import { ConvertResourceSnapshotsRequest } from '../models/ConvertResourceSnapshotsRequest';
import { ConvertResourceSnapshotsResponse } from '../models/ConvertResourceSnapshotsResponse';
import { Cost } from '../models/Cost';
import { CostDataFilters } from '../models/CostDataFilters';
import { CostDataGroupBy } from '../models/CostDataGroupBy';
import { CostDataRecord } from '../models/CostDataRecord';
import { CostDataRecordCost } from '../models/CostDataRecordCost';
import { CostDataRecordDimensions } from '../models/CostDataRecordDimensions';
import { CostGranularity } from '../models/CostGranularity';
import { CostRecordMetadata } from '../models/CostRecordMetadata';
import { CostRecordMetadataDataTransfer } from '../models/CostRecordMetadataDataTransfer';
import { CostRecordMetadataType } from '../models/CostRecordMetadataType';
import { CostUnit } from '../models/CostUnit';
import { CreateAccountInput } from '../models/CreateAccountInput';
import { CreateApiCredentialsRequest } from '../models/CreateApiCredentialsRequest';
import { CreateApiCredentialsResponse } from '../models/CreateApiCredentialsResponse';
import { CreateBackupPolicyRequest } from '../models/CreateBackupPolicyRequest';
import { CreateBackupPolicyResponse } from '../models/CreateBackupPolicyResponse';
import { CreateDashboardInput } from '../models/CreateDashboardInput';
import { CreateDlsgPolicyRequest } from '../models/CreateDlsgPolicyRequest';
import { CreateDlsgPolicyResponse } from '../models/CreateDlsgPolicyResponse';
import { CreateFabricTableShortcutDemoRequest } from '../models/CreateFabricTableShortcutDemoRequest';
import { CreateFabricTableShortcutDemoRequestShortcutsInner } from '../models/CreateFabricTableShortcutDemoRequestShortcutsInner';
import { CreateFabricTableShortcutDemoResponse } from '../models/CreateFabricTableShortcutDemoResponse';
import { CreateFabricTableShortcutDemoResponseResultsInner } from '../models/CreateFabricTableShortcutDemoResponseResultsInner';
import { CreateGraphInput, CreateGraphInputChartTypeEnum } from '../models/CreateGraphInput';
import { CreateIdpGroupRequest } from '../models/CreateIdpGroupRequest';
import { CreateIdpGroupResponse } from '../models/CreateIdpGroupResponse';
import { CreateInfectedExcludePathInput } from '../models/CreateInfectedExcludePathInput';
import { CreateIngestionPipelineInput } from '../models/CreateIngestionPipelineInput';
import { CreateIntegrationRequest } from '../models/CreateIntegrationRequest';
import { CreateIntegrationResponse } from '../models/CreateIntegrationResponse';
import { CreateJobTemplateInput } from '../models/CreateJobTemplateInput';
import { CreateNotebookInput } from '../models/CreateNotebookInput';
import { CreatePolicyInput } from '../models/CreatePolicyInput';
import { CreatePolicyScheduleInput } from '../models/CreatePolicyScheduleInput';
import { CreateProjectInput } from '../models/CreateProjectInput';
import { CreatePulumiConfigurationRequest } from '../models/CreatePulumiConfigurationRequest';
import { CreateRoleRequest } from '../models/CreateRoleRequest';
import { CreateRoleResponse } from '../models/CreateRoleResponse';
import { CreateSamlIdentityProviderConfigInput } from '../models/CreateSamlIdentityProviderConfigInput';
import { CreateSavedQueryInput } from '../models/CreateSavedQueryInput';
import { CreateScanJobInput } from '../models/CreateScanJobInput';
import { CreateScanJobResponse } from '../models/CreateScanJobResponse';
import { CreateSessionRequest } from '../models/CreateSessionRequest';
import { CreateSparkEngineInput } from '../models/CreateSparkEngineInput';
import { CreateSqlEngineInput, CreateSqlEngineInputWorkerSizeEnum } from '../models/CreateSqlEngineInput';
import { CreateUserInput } from '../models/CreateUserInput';
import { CreateVaultRequest } from '../models/CreateVaultRequest';
import { CreateVaultResponse } from '../models/CreateVaultResponse';
import { CrossResourceQueryRequest } from '../models/CrossResourceQueryRequest';
import { CrossResourceQueryRequestResourcesInner } from '../models/CrossResourceQueryRequestResourcesInner';
import { CustomTagsInner } from '../models/CustomTagsInner';
import { CustomerVaultAccount } from '../models/CustomerVaultAccount';
import { DBResourceMetadata } from '../models/DBResourceMetadata';
import { DBServerRecord } from '../models/DBServerRecord';
import { DBSnapshotMetadata } from '../models/DBSnapshotMetadata';
import { DBSnapshotType } from '../models/DBSnapshotType';
import { DailyConfig } from '../models/DailyConfig';
import { DailySnapshotData } from '../models/DailySnapshotData';
import { DailyStorageSummaries } from '../models/DailyStorageSummaries';
import { DailyStorageSummary } from '../models/DailyStorageSummary';
import { Dashboard } from '../models/Dashboard';
import { DashboardGraph, DashboardGraphChartTypeEnum } from '../models/DashboardGraph';
import { DashboardGraphLayout } from '../models/DashboardGraphLayout';
import { DashboardWithGraphs } from '../models/DashboardWithGraphs';
import { DataClass } from '../models/DataClass';
import { DataClassesCondition } from '../models/DataClassesCondition';
import { DataClassesDetails } from '../models/DataClassesDetails';
import { DataClassesFilters } from '../models/DataClassesFilters';
import { DataClassificationEntity } from '../models/DataClassificationEntity';
import { DataShareIntegrationConfig } from '../models/DataShareIntegrationConfig';
import { DataTransferOperationType } from '../models/DataTransferOperationType';
import { DatabaseDestination } from '../models/DatabaseDestination';
import { DatabaseRecord } from '../models/DatabaseRecord';
import { DatabricksIntegrationConfig } from '../models/DatabricksIntegrationConfig';
import { DayOfWeek } from '../models/DayOfWeek';
import { DeactivateAccountRequest } from '../models/DeactivateAccountRequest';
import { DeactivateAccountResponse } from '../models/DeactivateAccountResponse';
import { DeactivateGcpFolderResponse } from '../models/DeactivateGcpFolderResponse';
import { DeactivateGcpOrganizationResponse } from '../models/DeactivateGcpOrganizationResponse';
import { DestinationDetails } from '../models/DestinationDetails';
import { DestinationProviderAttributes } from '../models/DestinationProviderAttributes';
import { DestinationProviderAttributesAzure } from '../models/DestinationProviderAttributesAzure';
import { DestinationRestoreTypeAttributes } from '../models/DestinationRestoreTypeAttributes';
import { DisableResourceOverrideLimitsResponse } from '../models/DisableResourceOverrideLimitsResponse';
import { DisconnectCustomerVaultAccountResponse } from '../models/DisconnectCustomerVaultAccountResponse';
import { DisconnectRestoreAccountResponse } from '../models/DisconnectRestoreAccountResponse';
import { DisconnectSourceAccountResponse } from '../models/DisconnectSourceAccountResponse';
import { DisconnectSourceAwsOrganizationalUnitResponse } from '../models/DisconnectSourceAwsOrganizationalUnitResponse';
import { DiscoveryInvokeParams } from '../models/DiscoveryInvokeParams';
import { DiscoveryJob } from '../models/DiscoveryJob';
import { DiscoveryStatusResponse } from '../models/DiscoveryStatusResponse';
import { DlsgPolicy } from '../models/DlsgPolicy';
import { DlsgPolicyConfig } from '../models/DlsgPolicyConfig';
import { DlsgPolicyFilters } from '../models/DlsgPolicyFilters';
import { DlsgPolicyPlan } from '../models/DlsgPolicyPlan';
import { DlsgSettings } from '../models/DlsgSettings';
import { DriftProtectionPolicy } from '../models/DriftProtectionPolicy';
import { DriftProtectionSummary } from '../models/DriftProtectionSummary';
import { DriftProtectionTimePoint } from '../models/DriftProtectionTimePoint';
import { DynamoDBAdvancedIndexConfig } from '../models/DynamoDBAdvancedIndexConfig';
import { DynamoDBRestoreMethodAvailabilityRequest } from '../models/DynamoDBRestoreMethodAvailabilityRequest';
import { DynamoDBRestoreMethodAvailabilityResponse } from '../models/DynamoDBRestoreMethodAvailabilityResponse';
import { DynamoDbBackupConfig } from '../models/DynamoDbBackupConfig';
import { DynamoDbBackupConfigApplication } from '../models/DynamoDbBackupConfigApplication';
import { DynamoDbBillingMode } from '../models/DynamoDbBillingMode';
import { DynamodbTableRestoreDestination } from '../models/DynamodbTableRestoreDestination';
import { EFSRestoreDestination, EFSRestoreDestinationPerformanceModeEnum, EFSRestoreDestinationThroughputModeEnum } from '../models/EFSRestoreDestination';
import { EbsRestoreDestination } from '../models/EbsRestoreDestination';
import { EbsSnapshotRestoreDestination } from '../models/EbsSnapshotRestoreDestination';
import { EbsSnapshotTarget } from '../models/EbsSnapshotTarget';
import { EbsTarget } from '../models/EbsTarget';
import { EfsSnapshotProperties, EfsSnapshotPropertiesPerformanceModeEnum, EfsSnapshotPropertiesThroughputModeEnum } from '../models/EfsSnapshotProperties';
import { EksCluster } from '../models/EksCluster';
import { EksClusterStatus } from '../models/EksClusterStatus';
import { EksNamespaceRestoreDestination } from '../models/EksNamespaceRestoreDestination';
import { EksNamespaceRestoreResult } from '../models/EksNamespaceRestoreResult';
import { EksVolumeRestoreResult } from '../models/EksVolumeRestoreResult';
import { EmrIntegrationConfig } from '../models/EmrIntegrationConfig';
import { EnableFromLimitExceededResponse } from '../models/EnableFromLimitExceededResponse';
import { EnableResourceOverrideLimitsResponse } from '../models/EnableResourceOverrideLimitsResponse';
import { EnableRestoreAccountMetricsConfigRequest } from '../models/EnableRestoreAccountMetricsConfigRequest';
import { EnableRestoreAccountMetricsConfigResponse } from '../models/EnableRestoreAccountMetricsConfigResponse';
import { EnableSourceAccountMetricsConfigRequest } from '../models/EnableSourceAccountMetricsConfigRequest';
import { EnableSourceAccountMetricsConfigResponse } from '../models/EnableSourceAccountMetricsConfigResponse';
import { EncryptionKey } from '../models/EncryptionKey';
import { EncryptionKeys } from '../models/EncryptionKeys';
import { EndTimeDateFilters } from '../models/EndTimeDateFilters';
import { Environment } from '../models/Environment';
import { EnvironmentCondition } from '../models/EnvironmentCondition';
import { EnvironmentDetails } from '../models/EnvironmentDetails';
import { EnvironmentFilters } from '../models/EnvironmentFilters';
import { EonAccount } from '../models/EonAccount';
import { EonAccountIdFilters } from '../models/EonAccountIdFilters';
import { EonAccountStatus } from '../models/EonAccountStatus';
import { ErrorCode } from '../models/ErrorCode';
import { ExcludeFromBackupResponse } from '../models/ExcludeFromBackupResponse';
import { ExecuteNotebookCodeInput } from '../models/ExecuteNotebookCodeInput';
import { ExportCostData400Response } from '../models/ExportCostData400Response';
import { ExportCostDataRequest } from '../models/ExportCostDataRequest';
import { FSxRestoreDestination } from '../models/FSxRestoreDestination';
import { FSxRestoreDestinationOntapRestoreOptions } from '../models/FSxRestoreDestinationOntapRestoreOptions';
import { FileExplorerCountSecurityAlertsInResourceResponse } from '../models/FileExplorerCountSecurityAlertsInResourceResponse';
import { FileExplorerResponse } from '../models/FileExplorerResponse';
import { FilePath } from '../models/FilePath';
import { FileRestoreData } from '../models/FileRestoreData';
import { FileSearchRecord } from '../models/FileSearchRecord';
import { FileSnapshot } from '../models/FileSnapshot';
import { ForceDeleteSnapshotsRequest } from '../models/ForceDeleteSnapshotsRequest';
import { FreeTextFilters } from '../models/FreeTextFilters';
import { FsxBackupData } from '../models/FsxBackupData';
import { FsxOntapVolume, FsxOntapVolumeVolumeTypeEnum, FsxOntapVolumeSecurityStyleEnum } from '../models/FsxOntapVolume';
import { FsxSnapshotProperties } from '../models/FsxSnapshotProperties';
import { FsxVolumeBackupInfo } from '../models/FsxVolumeBackupInfo';
import { GCSBucket } from '../models/GCSBucket';
import { GCSBuckets } from '../models/GCSBuckets';
import { GCSRestoreDestination } from '../models/GCSRestoreDestination';
import { GCSRestoreTarget } from '../models/GCSRestoreTarget';
import { GcpAccountConfigInput } from '../models/GcpAccountConfigInput';
import { GcpBigQueryResource } from '../models/GcpBigQueryResource';
import { GcpBigQueryResourceMaterializedViewsInner } from '../models/GcpBigQueryResourceMaterializedViewsInner';
import { GcpBigQueryResourceRoutinesInner } from '../models/GcpBigQueryResourceRoutinesInner';
import { GcpBigQueryResourceTablesInner } from '../models/GcpBigQueryResourceTablesInner';
import { GcpBigQueryResourceViewsInner } from '../models/GcpBigQueryResourceViewsInner';
import { GcpCloudSqlResource } from '../models/GcpCloudSqlResource';
import { GcpCloudSqlResourceStorageSettings } from '../models/GcpCloudSqlResourceStorageSettings';
import { GcpCloudSqlRestoreDestination } from '../models/GcpCloudSqlRestoreDestination';
import { GcpCloudSqlSnapshotProperties } from '../models/GcpCloudSqlSnapshotProperties';
import { GcpCloudSqlTarget } from '../models/GcpCloudSqlTarget';
import { GcpDiskResource, GcpDiskResourceDiskTypeEnum, GcpDiskResourceStatusEnum } from '../models/GcpDiskResource';
import { GcpDiskRestoreData } from '../models/GcpDiskRestoreData';
import { GcpDiskRestoreDestination } from '../models/GcpDiskRestoreDestination';
import { GcpDiskSettings } from '../models/GcpDiskSettings';
import { GcpDiskSnapshotProperties } from '../models/GcpDiskSnapshotProperties';
import { GcpDiskTarget } from '../models/GcpDiskTarget';
import { GcpDiskTypesResponse } from '../models/GcpDiskTypesResponse';
import { GcpEncryptionKey } from '../models/GcpEncryptionKey';
import { GcpEncryptionKeys } from '../models/GcpEncryptionKeys';
import { GcpGkeNamespaceResource } from '../models/GcpGkeNamespaceResource';
import { GcpMachineTypesResponse } from '../models/GcpMachineTypesResponse';
import { GcpNetworkConnectivityConfig } from '../models/GcpNetworkConnectivityConfig';
import { GcpNetworkType } from '../models/GcpNetworkType';
import { GcpOrganization } from '../models/GcpOrganization';
import { GcpRestoreAccountAttributes } from '../models/GcpRestoreAccountAttributes';
import { GcpRestoreAccountAttributesInput } from '../models/GcpRestoreAccountAttributesInput';
import { GcpRestoreAccountConnectivityConfig } from '../models/GcpRestoreAccountConnectivityConfig';
import { GcpSourceAccountAttributes } from '../models/GcpSourceAccountAttributes';
import { GcpSourceAccountAttributesInput } from '../models/GcpSourceAccountAttributesInput';
import { GcpSubnet } from '../models/GcpSubnet';
import { GcpSubnetPerRegion } from '../models/GcpSubnetPerRegion';
import { GcpVaultConfig } from '../models/GcpVaultConfig';
import { GcpVaultConfigInput } from '../models/GcpVaultConfigInput';
import { GcpVmInstanceRestoreDestination } from '../models/GcpVmInstanceRestoreDestination';
import { GcpVmInstanceRestoreTarget } from '../models/GcpVmInstanceRestoreTarget';
import { GcpVmResource } from '../models/GcpVmResource';
import { GcpVmSnapshotProperties } from '../models/GcpVmSnapshotProperties';
import { GenericSnapshotData } from '../models/GenericSnapshotData';
import { GetAWSStackDetailsResponse } from '../models/GetAWSStackDetailsResponse';
import { GetBackupJobResponse } from '../models/GetBackupJobResponse';
import { GetBackupPolicyResponse } from '../models/GetBackupPolicyResponse';
import { GetBillingPeriodsResponse } from '../models/GetBillingPeriodsResponse';
import { GetBillingTransactionHistoryRequest } from '../models/GetBillingTransactionHistoryRequest';
import { GetBillingTransactionHistoryResponse } from '../models/GetBillingTransactionHistoryResponse';
import { GetCloudResourceSecurityPropertiesResponse } from '../models/GetCloudResourceSecurityPropertiesResponse';
import { GetCredits400Response } from '../models/GetCredits400Response';
import { GetCreditsResponse } from '../models/GetCreditsResponse';
import { GetDlsgPolicyResponse } from '../models/GetDlsgPolicyResponse';
import { GetGcsServiceAgentResponse } from '../models/GetGcsServiceAgentResponse';
import { GetIdpGroupResponse } from '../models/GetIdpGroupResponse';
import { GetIntegrationResponse } from '../models/GetIntegrationResponse';
import { GetLimitsResponseValue } from '../models/GetLimitsResponseValue';
import { GetNotebookContent200Response } from '../models/GetNotebookContent200Response';
import { GetProjectConfigurationKeyResponse } from '../models/GetProjectConfigurationKeyResponse';
import { GetProjectConfigurationKeysResponse } from '../models/GetProjectConfigurationKeysResponse';
import { GetResourceResponse } from '../models/GetResourceResponse';
import { GetRestoreAccountConnectivityConfigResponse } from '../models/GetRestoreAccountConnectivityConfigResponse';
import { GetRestoreAccountMetricsConfigResponse } from '../models/GetRestoreAccountMetricsConfigResponse';
import { GetRestoreJobResponse } from '../models/GetRestoreJobResponse';
import { GetRoleResponse } from '../models/GetRoleResponse';
import { GetScanJobResponse } from '../models/GetScanJobResponse';
import { GetSnapshotResponse } from '../models/GetSnapshotResponse';
import { GetSourceAccountMetricsConfigResponse } from '../models/GetSourceAccountMetricsConfigResponse';
import { GetSqlVmNetworkInfoRequest } from '../models/GetSqlVmNetworkInfoRequest';
import { GetSqlVmNetworkInfoResponse } from '../models/GetSqlVmNetworkInfoResponse';
import { GetVaultResponse } from '../models/GetVaultResponse';
import { GroupToRoleMapping } from '../models/GroupToRoleMapping';
import { HighFrequencyBackupPolicyPlan } from '../models/HighFrequencyBackupPolicyPlan';
import { HighFrequencyBackupResourceType } from '../models/HighFrequencyBackupResourceType';
import { HighFrequencyBackupScheduleConfig } from '../models/HighFrequencyBackupScheduleConfig';
import { HighFrequencyBackupScheduleFrequency } from '../models/HighFrequencyBackupScheduleFrequency';
import { HighFrequencyBackupSchedules } from '../models/HighFrequencyBackupSchedules';
import { HighFrequencyIntervalConfig, HighFrequencyIntervalConfigIntervalMinutesEnum } from '../models/HighFrequencyIntervalConfig';
import { IDs } from '../models/IDs';
import { IdFilters } from '../models/IdFilters';
import { Identifier } from '../models/Identifier';
import { IdentityProvidersNames } from '../models/IdentityProvidersNames';
import { Idp } from '../models/Idp';
import { IdpGroup } from '../models/IdpGroup';
import { ImportDlsgCertificateRequest } from '../models/ImportDlsgCertificateRequest';
import { IndexRestoreMode } from '../models/IndexRestoreMode';
import { InfectedDataByClassification } from '../models/InfectedDataByClassification';
import { InfectedDataClassificationSize } from '../models/InfectedDataClassificationSize';
import { InfectedDataOverTime } from '../models/InfectedDataOverTime';
import { InfectedDateSize } from '../models/InfectedDateSize';
import { InfectedExcludePath } from '../models/InfectedExcludePath';
import { InfectedResourcesCountResponse } from '../models/InfectedResourcesCountResponse';
import { IngestionPipeline } from '../models/IngestionPipeline';
import { IngestionPipelineStatus } from '../models/IngestionPipelineStatus';
import { IngestionSourceType } from '../models/IngestionSourceType';
import { InitAuthInput } from '../models/InitAuthInput';
import { Initiator } from '../models/Initiator';
import { InitiatorNameFilters } from '../models/InitiatorNameFilters';
import { IntegConfig } from '../models/IntegConfig';
import { IntegType } from '../models/IntegType';
import { IntegrationConfig } from '../models/IntegrationConfig';
import { InventoryFilterConditions } from '../models/InventoryFilterConditions';
import { InventoryGcpDisk } from '../models/InventoryGcpDisk';
import { InventoryResource } from '../models/InventoryResource';
import { InventoryResourceMetadata } from '../models/InventoryResourceMetadata';
import { InventorySnapshotVolume } from '../models/InventorySnapshotVolume';
import { InventoryVault } from '../models/InventoryVault';
import { InventoryVolume } from '../models/InventoryVolume';
import { IssueMutedNotificationArguments } from '../models/IssueMutedNotificationArguments';
import { JobExecutionDetails } from '../models/JobExecutionDetails';
import { JobFailedNotificationArguments } from '../models/JobFailedNotificationArguments';
import { JobIdFilters } from '../models/JobIdFilters';
import { JobInitiationResponse } from '../models/JobInitiationResponse';
import { JobMetricsReportFailedArguments } from '../models/JobMetricsReportFailedArguments';
import { JobSnapshotDetails } from '../models/JobSnapshotDetails';
import { JobStatus } from '../models/JobStatus';
import { JobStatusFilters } from '../models/JobStatusFilters';
import { JobStep } from '../models/JobStep';
import { JobStepName } from '../models/JobStepName';
import { JobStepStatus } from '../models/JobStepStatus';
import { JobSucceededNotificationArguments } from '../models/JobSucceededNotificationArguments';
import { JobTemplate } from '../models/JobTemplate';
import { KubeAccessStatus } from '../models/KubeAccessStatus';
import { KubernetesAccessMode } from '../models/KubernetesAccessMode';
import { LimitData } from '../models/LimitData';
import { ListAccountsResponse } from '../models/ListAccountsResponse';
import { ListApiCredentialsResponse } from '../models/ListApiCredentialsResponse';
import { ListApplicationOverrideResponse } from '../models/ListApplicationOverrideResponse';
import { ListAuditLogRequest } from '../models/ListAuditLogRequest';
import { ListAuditLogResponse } from '../models/ListAuditLogResponse';
import { ListAuditLogsResponse } from '../models/ListAuditLogsResponse';
import { ListAzureRegions200Response } from '../models/ListAzureRegions200Response';
import { ListAzureSKUs200Response } from '../models/ListAzureSKUs200Response';
import { ListAzureSKUs200ResponseSkusInner } from '../models/ListAzureSKUs200ResponseSkusInner';
import { ListAzureSKUsRequest } from '../models/ListAzureSKUsRequest';
import { ListAzureStorageAccountContainers200Response } from '../models/ListAzureStorageAccountContainers200Response';
import { ListAzureStorageAccountContainersRequest } from '../models/ListAzureStorageAccountContainersRequest';
import { ListAzureSubnets200Response } from '../models/ListAzureSubnets200Response';
import { ListAzureSubnets200ResponseSubnetsInner } from '../models/ListAzureSubnets200ResponseSubnetsInner';
import { ListAzureSubnetsRequest } from '../models/ListAzureSubnetsRequest';
import { ListAzureUnassignedNetworkInterfaces200Response } from '../models/ListAzureUnassignedNetworkInterfaces200Response';
import { ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner } from '../models/ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner';
import { ListAzureUnassignedNetworkInterfacesRequest } from '../models/ListAzureUnassignedNetworkInterfacesRequest';
import { ListAzureVirtualNetworks200Response } from '../models/ListAzureVirtualNetworks200Response';
import { ListAzureVirtualNetworks200ResponseVirtualNetworksInner } from '../models/ListAzureVirtualNetworks200ResponseVirtualNetworksInner';
import { ListAzureVirtualNetworksRequest } from '../models/ListAzureVirtualNetworksRequest';
import { ListBackupJobTypesResponse } from '../models/ListBackupJobTypesResponse';
import { ListBackupJobsInternal200Response } from '../models/ListBackupJobsInternal200Response';
import { ListBackupJobsRequest } from '../models/ListBackupJobsRequest';
import { ListBackupJobsResponse } from '../models/ListBackupJobsResponse';
import { ListBackupPoliciesResponse } from '../models/ListBackupPoliciesResponse';
import { ListBackupPolicyResponse } from '../models/ListBackupPolicyResponse';
import { ListBackupVaultResponse } from '../models/ListBackupVaultResponse';
import { ListCloudSnapshotsResponse } from '../models/ListCloudSnapshotsResponse';
import { ListControlViolationsResponse } from '../models/ListControlViolationsResponse';
import { ListControlsResponse } from '../models/ListControlsResponse';
import { ListDailySnapshotsResponse } from '../models/ListDailySnapshotsResponse';
import { ListDashboardsResponse } from '../models/ListDashboardsResponse';
import { ListDataClassificationEntitiesResponse } from '../models/ListDataClassificationEntitiesResponse';
import { ListDatabaseSnapshotsResponse } from '../models/ListDatabaseSnapshotsResponse';
import { ListDlsgPoliciesResponse } from '../models/ListDlsgPoliciesResponse';
import { ListDynamoDbBackupConfigsResponse } from '../models/ListDynamoDbBackupConfigsResponse';
import { ListEksClustersResponse } from '../models/ListEksClustersResponse';
import { ListGcpFoldersResponse } from '../models/ListGcpFoldersResponse';
import { ListGcpNetworksResponse } from '../models/ListGcpNetworksResponse';
import { ListGcpNetworksResponseNetworksInner } from '../models/ListGcpNetworksResponseNetworksInner';
import { ListGcpOrganizationsResponse } from '../models/ListGcpOrganizationsResponse';
import { ListGcpSubnetsResponse } from '../models/ListGcpSubnetsResponse';
import { ListIdpGroupsResponse } from '../models/ListIdpGroupsResponse';
import { ListIdpsResponse } from '../models/ListIdpsResponse';
import { ListInfectedExcludePathsResponse } from '../models/ListInfectedExcludePathsResponse';
import { ListIngestionPipelinesResponse } from '../models/ListIngestionPipelinesResponse';
import { ListInstanceProfilesResponse } from '../models/ListInstanceProfilesResponse';
import { ListInstanceTypesResponse } from '../models/ListInstanceTypesResponse';
import { ListIntegrationsResponse } from '../models/ListIntegrationsResponse';
import { ListInventoryAppsResponse } from '../models/ListInventoryAppsResponse';
import { ListInventoryBackupRegionsResponse } from '../models/ListInventoryBackupRegionsResponse';
import { ListInventoryEnvironmentsResponse } from '../models/ListInventoryEnvironmentsResponse';
import { ListInventoryGlobalDatabasesResponse } from '../models/ListInventoryGlobalDatabasesResponse';
import { ListInventoryItemSnapshotsResponse } from '../models/ListInventoryItemSnapshotsResponse';
import { ListInventoryNetworksResponse } from '../models/ListInventoryNetworksResponse';
import { ListInventoryRequest } from '../models/ListInventoryRequest';
import { ListInventoryResourceGroupsResponse } from '../models/ListInventoryResourceGroupsResponse';
import { ListInventoryResourceIdentifiersResponse } from '../models/ListInventoryResourceIdentifiersResponse';
import { ListInventoryResourceTypesResponse } from '../models/ListInventoryResourceTypesResponse';
import { ListInventoryResourcesResponse } from '../models/ListInventoryResourcesResponse';
import { ListInventorySnapshotsRequest } from '../models/ListInventorySnapshotsRequest';
import { ListInventorySnapshotsResponse } from '../models/ListInventorySnapshotsResponse';
import { ListInventorySourceRegionsResponse } from '../models/ListInventorySourceRegionsResponse';
import { ListInventorySubnetsResponse } from '../models/ListInventorySubnetsResponse';
import { ListInventoryTagsResponse } from '../models/ListInventoryTagsResponse';
import { ListJobErrorCodesResponse } from '../models/ListJobErrorCodesResponse';
import { ListJobTemplatesResponse } from '../models/ListJobTemplatesResponse';
import { ListKnownAppsResponse } from '../models/ListKnownAppsResponse';
import { ListLogSourcesPoliciesResponse } from '../models/ListLogSourcesPoliciesResponse';
import { ListLogSourcesResponse } from '../models/ListLogSourcesResponse';
import { ListNotebooksResponse } from '../models/ListNotebooksResponse';
import { ListNotificationPoliciesResponse } from '../models/ListNotificationPoliciesResponse';
import { ListNotificationsResponse } from '../models/ListNotificationsResponse';
import { ListObjectStoreExclusionRulesResponse } from '../models/ListObjectStoreExclusionRulesResponse';
import { ListOperators } from '../models/ListOperators';
import { ListPermissionsResponse } from '../models/ListPermissionsResponse';
import { ListProjectsResponse } from '../models/ListProjectsResponse';
import { ListResourceAttachmentEventsResponse } from '../models/ListResourceAttachmentEventsResponse';
import { ListResourcesResponse } from '../models/ListResourcesResponse';
import { ListRestoreAccountsRequest } from '../models/ListRestoreAccountsRequest';
import { ListRestoreAccountsResponse } from '../models/ListRestoreAccountsResponse';
import { ListRestoreJobTypesResponse } from '../models/ListRestoreJobTypesResponse';
import { ListRestoreJobsInternal200Response } from '../models/ListRestoreJobsInternal200Response';
import { ListRestoreJobsRequest } from '../models/ListRestoreJobsRequest';
import { ListRestoreJobsResponse } from '../models/ListRestoreJobsResponse';
import { ListRolesResponse } from '../models/ListRolesResponse';
import { ListSavedQueriesResponse } from '../models/ListSavedQueriesResponse';
import { ListScanJobTypesResponse } from '../models/ListScanJobTypesResponse';
import { ListScanJobsInternal200Response } from '../models/ListScanJobsInternal200Response';
import { ListScanJobsRequest } from '../models/ListScanJobsRequest';
import { ListScanJobsResponse } from '../models/ListScanJobsResponse';
import { ListSensitivityAnnotationsResponse } from '../models/ListSensitivityAnnotationsResponse';
import { ListSourceAccountsRequest } from '../models/ListSourceAccountsRequest';
import { ListSourceAccountsResponse } from '../models/ListSourceAccountsResponse';
import { ListSourceAwsOrganizationalUnitsResponse } from '../models/ListSourceAwsOrganizationalUnitsResponse';
import { ListSparkEnginesResponse } from '../models/ListSparkEnginesResponse';
import { ListSparkJobsResponse } from '../models/ListSparkJobsResponse';
import { ListSqlEnginesResponse } from '../models/ListSqlEnginesResponse';
import { ListSqlQueryExecutionsResponse } from '../models/ListSqlQueryExecutionsResponse';
import { ListStorageGatewaysResponse } from '../models/ListStorageGatewaysResponse';
import { ListSubnetsResponse } from '../models/ListSubnetsResponse';
import { ListSubnetsResponseV2 } from '../models/ListSubnetsResponseV2';
import { ListSubnetsResponseV2SubnetsInner } from '../models/ListSubnetsResponseV2SubnetsInner';
import { ListUsersResponse } from '../models/ListUsersResponse';
import { LlgLocationResource } from '../models/LlgLocationResource';
import { LlgLocationWithResources } from '../models/LlgLocationWithResources';
import { LlgResourcePolicy } from '../models/LlgResourcePolicy';
import { LogRecord } from '../models/LogRecord';
import { LogSource, LogSourceTypeEnum } from '../models/LogSource';
import { LogSourceLocation } from '../models/LogSourceLocation';
import { LogSourceLocationCloudTrail } from '../models/LogSourceLocationCloudTrail';
import { LogSourceLocationCloudWatchLogs } from '../models/LogSourceLocationCloudWatchLogs';
import { LogSourceLocationDatadog } from '../models/LogSourceLocationDatadog';
import { LogSourceLocationSplunkDdss } from '../models/LogSourceLocationSplunkDdss';
import { LogSourceWithPolicy, LogSourceWithPolicyTypeEnum } from '../models/LogSourceWithPolicy';
import { LogicalOperator } from '../models/LogicalOperator';
import { LogsHistogramDataPoint } from '../models/LogsHistogramDataPoint';
import { LogsSchema } from '../models/LogsSchema';
import { LogsSchemaColumn } from '../models/LogsSchemaColumn';
import { LogsSchemaEntry } from '../models/LogsSchemaEntry';
import { LogsSchemasResponse } from '../models/LogsSchemasResponse';
import { LuceneQueryInput } from '../models/LuceneQueryInput';
import { MaxRetentionRule } from '../models/MaxRetentionRule';
import { Message } from '../models/Message';
import { MeteringDimension } from '../models/MeteringDimension';
import { MicrosoftFabricIntegrationConfig } from '../models/MicrosoftFabricIntegrationConfig';
import { MinRetentionRule, MinRetentionRuleFrequencyEnum } from '../models/MinRetentionRule';
import { ModelError } from '../models/ModelError';
import { MonthlyConfig } from '../models/MonthlyConfig';
import { MonthlySnapshotData } from '../models/MonthlySnapshotData';
import { MsaAcceptanceResponse } from '../models/MsaAcceptanceResponse';
import { NativeStandardBackupPolicyPlan } from '../models/NativeStandardBackupPolicyPlan';
import { NativeStandardBackupSchedules } from '../models/NativeStandardBackupSchedules';
import { NetworkInterfaceConfig, NetworkInterfaceConfigModeEnum } from '../models/NetworkInterfaceConfig';
import { Notebook } from '../models/Notebook';
import { NotebookExecutionOutput, NotebookExecutionOutputTypeEnum } from '../models/NotebookExecutionOutput';
import { NotebookExecutionResult, NotebookExecutionResultStatusEnum } from '../models/NotebookExecutionResult';
import { NotebookSession } from '../models/NotebookSession';
import { NotebookSessionStatus } from '../models/NotebookSessionStatus';
import { Notification } from '../models/Notification';
import { NotificationArguments } from '../models/NotificationArguments';
import { NotificationPolicy, NotificationPolicyTypeEnum } from '../models/NotificationPolicy';
import { NotificationPolicyConfig } from '../models/NotificationPolicyConfig';
import { NotificationPolicyConfigEmail } from '../models/NotificationPolicyConfigEmail';
import { NotificationPolicyConfigServiceNow } from '../models/NotificationPolicyConfigServiceNow';
import { NotificationPolicyConfigSlack } from '../models/NotificationPolicyConfigSlack';
import { NotificationPolicyConfigSns } from '../models/NotificationPolicyConfigSns';
import { NotificationPolicyConfigSplunk } from '../models/NotificationPolicyConfigSplunk';
import { NotificationPolicyConfigWebhook } from '../models/NotificationPolicyConfigWebhook';
import { NotificationStatus } from '../models/NotificationStatus';
import { NotificationType } from '../models/NotificationType';
import { NumberOfCopiesRule } from '../models/NumberOfCopiesRule';
import { Oauth2TokenResponse } from '../models/Oauth2TokenResponse';
import { ObjectStorageDestination } from '../models/ObjectStorageDestination';
import { ObjectStoreExclusionRule, ObjectStoreExclusionRuleStoreTypeEnum } from '../models/ObjectStoreExclusionRule';
import { OnboardingAzureResourceGroup } from '../models/OnboardingAzureResourceGroup';
import { OperationIdFilters } from '../models/OperationIdFilters';
import { OrganizationIdFilters } from '../models/OrganizationIdFilters';
import { OverrideDataClassificationsRequest } from '../models/OverrideDataClassificationsRequest';
import { OverrideDataClassificationsResponse } from '../models/OverrideDataClassificationsResponse';
import { OverrideEnvironmentRequest } from '../models/OverrideEnvironmentRequest';
import { OverrideEnvironmentResponse } from '../models/OverrideEnvironmentResponse';
import { Pagination } from '../models/Pagination';
import { PartialRestoreData } from '../models/PartialRestoreData';
import { PartialRestoreType } from '../models/PartialRestoreType';
import { Path } from '../models/Path';
import { PathSnapshotsRequest } from '../models/PathSnapshotsRequest';
import { PathSnapshotsResponse } from '../models/PathSnapshotsResponse';
import { PathType } from '../models/PathType';
import { Permission } from '../models/Permission';
import { PermissionCategory } from '../models/PermissionCategory';
import { PermissionGrant } from '../models/PermissionGrant';
import { PermissionGrantInput } from '../models/PermissionGrantInput';
import { PermissionType } from '../models/PermissionType';
import { PersistentVolumeClaimProperties } from '../models/PersistentVolumeClaimProperties';
import { PitrBackupPolicyPlan } from '../models/PitrBackupPolicyPlan';
import { PitrBackupResourceType } from '../models/PitrBackupResourceType';
import { PitrBackupSchedules } from '../models/PitrBackupSchedules';
import { PitrIntervalConfig, PitrIntervalConfigIntervalMinutesEnum } from '../models/PitrIntervalConfig';
import { PitrRestoreVaultWindows } from '../models/PitrRestoreVaultWindows';
import { PitrRestoreWindow } from '../models/PitrRestoreWindow';
import { PitrRestoreWindowsResponse } from '../models/PitrRestoreWindowsResponse';
import { Preferences } from '../models/Preferences';
import { Project } from '../models/Project';
import { ProjectConfigurationKeyEnum } from '../models/ProjectConfigurationKeyEnum';
import { ProjectIdFilters } from '../models/ProjectIdFilters';
import { Provider } from '../models/Provider';
import { ProviderAccountIdFilters } from '../models/ProviderAccountIdFilters';
import { ProviderOrganizationIdFilters } from '../models/ProviderOrganizationIdFilters';
import { ProviderRestoreAccountConnectivityConfig } from '../models/ProviderRestoreAccountConnectivityConfig';
import { PulumiConfiguration } from '../models/PulumiConfiguration';
import { PulumiConfigurations } from '../models/PulumiConfigurations';
import { PulumiConfigurationsFilterConditions } from '../models/PulumiConfigurationsFilterConditions';
import { PulumiConfigurationsRequest } from '../models/PulumiConfigurationsRequest';
import { QueryCostData400Response } from '../models/QueryCostData400Response';
import { QueryCostDataRequest } from '../models/QueryCostDataRequest';
import { QueryCostDataResponse } from '../models/QueryCostDataResponse';
import { QueryDBRequest } from '../models/QueryDBRequest';
import { QueryDBResponse } from '../models/QueryDBResponse';
import { QueryDBRestoreDestination } from '../models/QueryDBRestoreDestination';
import { QueryDBRestoreDestinationType } from '../models/QueryDBRestoreDestinationType';
import { QueryDBResultResponse } from '../models/QueryDBResultResponse';
import { QueryDBStatus } from '../models/QueryDBStatus';
import { QueryDBStatusResponse } from '../models/QueryDBStatusResponse';
import { QuotaStatus } from '../models/QuotaStatus';
import { QuotaStatusFilters } from '../models/QuotaStatusFilters';
import { RansomwareResourceNotificationArguments } from '../models/RansomwareResourceNotificationArguments';
import { RansomwareSnapshotNotificationArguments } from '../models/RansomwareSnapshotNotificationArguments';
import { RdsNativePitrAdvancedConfig } from '../models/RdsNativePitrAdvancedConfig';
import { RdsNativePitrClusterAdvancedConfig } from '../models/RdsNativePitrClusterAdvancedConfig';
import { RdsNativePitrNetworkConfig } from '../models/RdsNativePitrNetworkConfig';
import { RdsNativePitrWindow } from '../models/RdsNativePitrWindow';
import { ReactivateAccountRequest } from '../models/ReactivateAccountRequest';
import { ReconnectCustomerVaultAccountResponse } from '../models/ReconnectCustomerVaultAccountResponse';
import { ReconnectRestoreAccountResponse } from '../models/ReconnectRestoreAccountResponse';
import { ReconnectSourceAccountResponse } from '../models/ReconnectSourceAccountResponse';
import { ReconnectSourceAwsOrganizationalUnitResponse } from '../models/ReconnectSourceAwsOrganizationalUnitResponse';
import { RecordRestoreResult } from '../models/RecordRestoreResult';
import { RedshiftCluster } from '../models/RedshiftCluster';
import { RedshiftClusters } from '../models/RedshiftClusters';
import { RedshiftIntegrationConfig } from '../models/RedshiftIntegrationConfig';
import { RegionCondition } from '../models/RegionCondition';
import { RegisterInput } from '../models/RegisterInput';
import { RegisterInputBillingToken } from '../models/RegisterInputBillingToken';
import { RegisterResponse } from '../models/RegisterResponse';
import { RelatedGlobalDbCluster } from '../models/RelatedGlobalDbCluster';
import { RequestDetails } from '../models/RequestDetails';
import { ResourceDetails } from '../models/ResourceDetails';
import { ResourceGroupNameCondition } from '../models/ResourceGroupNameCondition';
import { ResourceIdCondition } from '../models/ResourceIdCondition';
import { ResourceIdFilters } from '../models/ResourceIdFilters';
import { ResourceIdentifiers } from '../models/ResourceIdentifiers';
import { ResourceNameCondition } from '../models/ResourceNameCondition';
import { ResourceNameFilters } from '../models/ResourceNameFilters';
import { ResourceProperties } from '../models/ResourceProperties';
import { ResourceSelectorMode } from '../models/ResourceSelectorMode';
import { ResourceSnapshot } from '../models/ResourceSnapshot';
import { ResourceSnapshotProperties } from '../models/ResourceSnapshotProperties';
import { ResourceSortField } from '../models/ResourceSortField';
import { ResourceTag } from '../models/ResourceTag';
import { ResourceType } from '../models/ResourceType';
import { ResourceTypeCondition } from '../models/ResourceTypeCondition';
import { ResourceTypeFilters } from '../models/ResourceTypeFilters';
import { ResourceTypeToSecurityGroup } from '../models/ResourceTypeToSecurityGroup';
import { ResourceValidationError } from '../models/ResourceValidationError';
import { RestoreAccount } from '../models/RestoreAccount';
import { RestoreAccountAttributesInput } from '../models/RestoreAccountAttributesInput';
import { RestoreAccountCloudAttributes } from '../models/RestoreAccountCloudAttributes';
import { RestoreAccountConnectivityConfig } from '../models/RestoreAccountConnectivityConfig';
import { RestoreAccountMetricsConfig } from '../models/RestoreAccountMetricsConfig';
import { RestoreAccountRegions } from '../models/RestoreAccountRegions';
import { RestoreAccountSortField } from '../models/RestoreAccountSortField';
import { RestoreAccountsFilterConditions } from '../models/RestoreAccountsFilterConditions';
import { RestoreAtlasClusterInput } from '../models/RestoreAtlasClusterInput';
import { RestoreAvailabilityZones } from '../models/RestoreAvailabilityZones';
import { RestoreAwsEc2InstanceRequest } from '../models/RestoreAwsEc2InstanceRequest';
import { RestoreAzureDiskConfig } from '../models/RestoreAzureDiskConfig';
import { RestoreAzureDiskRequest } from '../models/RestoreAzureDiskRequest';
import { RestoreAzureInstanceDiskInput } from '../models/RestoreAzureInstanceDiskInput';
import { RestoreAzureSqlDatabaseRequest } from '../models/RestoreAzureSqlDatabaseRequest';
import { RestoreAzureSqlVmPitrRequest } from '../models/RestoreAzureSqlVmPitrRequest';
import { RestoreAzureVMInstanceConfig } from '../models/RestoreAzureVMInstanceConfig';
import { RestoreAzureVmInstanceRequest } from '../models/RestoreAzureVmInstanceRequest';
import { RestoreBigQueryDatasetRequest } from '../models/RestoreBigQueryDatasetRequest';
import { RestoreBucketRequest } from '../models/RestoreBucketRequest';
import { RestoreDbToRdsInstanceRequest } from '../models/RestoreDbToRdsInstanceRequest';
import { RestoreDbToRdsSnapshotRequest } from '../models/RestoreDbToRdsSnapshotRequest';
import { RestoreDynamoDBTableRequest } from '../models/RestoreDynamoDBTableRequest';
import { RestoreDynamoDBToExistingTableRequest } from '../models/RestoreDynamoDBToExistingTableRequest';
import { RestoreDynamoDbTableConfig } from '../models/RestoreDynamoDbTableConfig';
import { RestoreEFSRequest } from '../models/RestoreEFSRequest';
import { RestoreEbsVolumeConfig } from '../models/RestoreEbsVolumeConfig';
import { RestoreEc2InstanceConfig } from '../models/RestoreEc2InstanceConfig';
import { RestoreEksNamespaceConfig } from '../models/RestoreEksNamespaceConfig';
import { RestoreEksNamespaceInput } from '../models/RestoreEksNamespaceInput';
import { RestoreEksNamespaceVolumeInput } from '../models/RestoreEksNamespaceVolumeInput';
import { RestoreFSxRequest } from '../models/RestoreFSxRequest';
import { RestoreFilesRequest } from '../models/RestoreFilesRequest';
import { RestoreGceDiskConfig } from '../models/RestoreGceDiskConfig';
import { RestoreGceInstanceConfig } from '../models/RestoreGceInstanceConfig';
import { RestoreGcpCloudSqlDatabaseConfig } from '../models/RestoreGcpCloudSqlDatabaseConfig';
import { RestoreGcpCloudSqlRequest } from '../models/RestoreGcpCloudSqlRequest';
import { RestoreGcpDiskRequest } from '../models/RestoreGcpDiskRequest';
import { RestoreGcpInstanceDiskInput } from '../models/RestoreGcpInstanceDiskInput';
import { RestoreGcpVmInstanceRequest } from '../models/RestoreGcpVmInstanceRequest';
import { RestoreImageImageDeviceInput } from '../models/RestoreImageImageDeviceInput';
import { RestoreImageImageInput } from '../models/RestoreImageImageInput';
import { RestoreImageInput } from '../models/RestoreImageInput';
import { RestoreImageVolumeInput } from '../models/RestoreImageVolumeInput';
import { RestoreInstanceImageDeviceInput } from '../models/RestoreInstanceImageDeviceInput';
import { RestoreInstanceImageInput } from '../models/RestoreInstanceImageInput';
import { RestoreInstanceVolumeInput } from '../models/RestoreInstanceVolumeInput';
import { RestoreJob } from '../models/RestoreJob';
import { RestoreJobConfiguration } from '../models/RestoreJobConfiguration';
import { RestoreJobInitiationResponse } from '../models/RestoreJobInitiationResponse';
import { RestoreJobSortField } from '../models/RestoreJobSortField';
import { RestoreJobType } from '../models/RestoreJobType';
import { RestoreJobTypeFilters } from '../models/RestoreJobTypeFilters';
import { RestoreJobsFilterConditions } from '../models/RestoreJobsFilterConditions';
import { RestoreMethod } from '../models/RestoreMethod';
import { RestoreMethodAvailabilityReason } from '../models/RestoreMethodAvailabilityReason';
import { RestoreRdsInstanceClasses } from '../models/RestoreRdsInstanceClasses';
import { RestoreRdsInstanceConfig } from '../models/RestoreRdsInstanceConfig';
import { RestoreRdsNativePitrRequest } from '../models/RestoreRdsNativePitrRequest';
import { RestoreRdsSubnetGroups } from '../models/RestoreRdsSubnetGroups';
import { RestoreRdsSubnetGroupsRdsSubnetGroupsInner } from '../models/RestoreRdsSubnetGroupsRdsSubnetGroupsInner';
import { RestoreResult } from '../models/RestoreResult';
import { RestoreSecurityGroups } from '../models/RestoreSecurityGroups';
import { RestoreSecurityGroupsSecurityGroupsInner } from '../models/RestoreSecurityGroupsSecurityGroupsInner';
import { RestoreVolumeToEbsRequest } from '../models/RestoreVolumeToEbsRequest';
import { RestoreVolumeToEbsSnapshotRequest } from '../models/RestoreVolumeToEbsSnapshotRequest';
import { Role } from '../models/Role';
import { RoleAccessGroupCondition } from '../models/RoleAccessGroupCondition';
import { RoleInstallationMethod } from '../models/RoleInstallationMethod';
import { S3Bucket } from '../models/S3Bucket';
import { S3Buckets } from '../models/S3Buckets';
import { S3RestoreDestination } from '../models/S3RestoreDestination';
import { S3RestoreTarget } from '../models/S3RestoreTarget';
import { S3SourceProperties } from '../models/S3SourceProperties';
import { SAMLCallback400Response } from '../models/SAMLCallback400Response';
import { SAMLCallback401Response } from '../models/SAMLCallback401Response';
import { SAMLCallback500Response } from '../models/SAMLCallback500Response';
import { SamlIdentityProvider } from '../models/SamlIdentityProvider';
import { SamlIdentityProviderConfigsResponse } from '../models/SamlIdentityProviderConfigsResponse';
import { SapHanaInstance } from '../models/SapHanaInstance';
import { SapHanaRestoreProperties } from '../models/SapHanaRestoreProperties';
import { SaveCloudResourceSecurityPropertiesRequest } from '../models/SaveCloudResourceSecurityPropertiesRequest';
import { SaveNotebookContentRequest } from '../models/SaveNotebookContentRequest';
import { SavedQuery } from '../models/SavedQuery';
import { ScalarOperators } from '../models/ScalarOperators';
import { ScanJob } from '../models/ScanJob';
import { ScanJobType } from '../models/ScanJobType';
import { ScheduleMode } from '../models/ScheduleMode';
import { ScheduleType } from '../models/ScheduleType';
import { SchemaRecord } from '../models/SchemaRecord';
import { SearchDBResponse } from '../models/SearchDBResponse';
import { SearchFilesResponse } from '../models/SearchFilesResponse';
import { SearchInput } from '../models/SearchInput';
import { SearchLogsHistogramInput } from '../models/SearchLogsHistogramInput';
import { SearchLogsHistogramResponse } from '../models/SearchLogsHistogramResponse';
import { SearchLogsInput } from '../models/SearchLogsInput';
import { SearchLogsResponse } from '../models/SearchLogsResponse';
import { SearchResources200Response } from '../models/SearchResources200Response';
import { SearchResources200ResponseTablesInner } from '../models/SearchResources200ResponseTablesInner';
import { SearchResources200ResponseTablesInnerResource } from '../models/SearchResources200ResponseTablesInnerResource';
import { SearchResources200ResponseTablesInnerSnapshots } from '../models/SearchResources200ResponseTablesInnerSnapshots';
import { SearchResources200ResponseTablesInnerSource } from '../models/SearchResources200ResponseTablesInnerSource';
import { SearchResources200ResponseTablesInnerTablesInner } from '../models/SearchResources200ResponseTablesInnerTablesInner';
import { SearchResources200ResponseTablesInnerTablesInnerColumnsInner } from '../models/SearchResources200ResponseTablesInnerTablesInnerColumnsInner';
import { SearchResourcesRequest } from '../models/SearchResourcesRequest';
import { SecurityAssignmentStatus } from '../models/SecurityAssignmentStatus';
import { SecurityInformation } from '../models/SecurityInformation';
import { SecurityPlan } from '../models/SecurityPlan';
import { SecurityPlanEnabledResponse } from '../models/SecurityPlanEnabledResponse';
import { SecurityScan, SecurityScanConclusionEnum, SecurityScanDetectorTypeEnum } from '../models/SecurityScan';
import { SecurityScanExample, SecurityScanExampleTypeEnum } from '../models/SecurityScanExample';
import { SecurityScanResult, SecurityScanResultEvidenceTypeEnum } from '../models/SecurityScanResult';
import { SecurityScansSummaryResponse } from '../models/SecurityScansSummaryResponse';
import { SecuritySummary } from '../models/SecuritySummary';
import { SendMessageToAI400Response } from '../models/SendMessageToAI400Response';
import { SendMessageToAIRequest } from '../models/SendMessageToAIRequest';
import { SensitivityAnnotation } from '../models/SensitivityAnnotation';
import { ServiceProviderDetails } from '../models/ServiceProviderDetails';
import { Session } from '../models/Session';
import { Severity } from '../models/Severity';
import { SeverityFilters } from '../models/SeverityFilters';
import { Snapshot } from '../models/Snapshot';
import { SnapshotDateFilters } from '../models/SnapshotDateFilters';
import { SnapshotFilterConditions } from '../models/SnapshotFilterConditions';
import { SnapshotIdFilters } from '../models/SnapshotIdFilters';
import { SnapshotLocation, SnapshotLocationSnapshotTypeEnum } from '../models/SnapshotLocation';
import { SnapshotReference } from '../models/SnapshotReference';
import { SnapshotSortField } from '../models/SnapshotSortField';
import { SnapshotStatus } from '../models/SnapshotStatus';
import { SnapshotStorage } from '../models/SnapshotStorage';
import { SnapshotsSummaryResponse } from '../models/SnapshotsSummaryResponse';
import { SnowflakeIntegrationConfig } from '../models/SnowflakeIntegrationConfig';
import { SortBackupJobBy } from '../models/SortBackupJobBy';
import { SortLogsBy, SortLogsByFieldEnum } from '../models/SortLogsBy';
import { SortOrder } from '../models/SortOrder';
import { SortResourceBy } from '../models/SortResourceBy';
import { SortRestoreAccountsBy } from '../models/SortRestoreAccountsBy';
import { SortRestoreJobBy } from '../models/SortRestoreJobBy';
import { SortSnapshotsBy } from '../models/SortSnapshotsBy';
import { SortSourceAccountsBy } from '../models/SortSourceAccountsBy';
import { SourceAccount } from '../models/SourceAccount';
import { SourceAccountAttributesInput } from '../models/SourceAccountAttributesInput';
import { SourceAccountCloudAttributes } from '../models/SourceAccountCloudAttributes';
import { SourceAccountMetricsConfig } from '../models/SourceAccountMetricsConfig';
import { SourceAccountProviderIdFilters } from '../models/SourceAccountProviderIdFilters';
import { SourceAccountSortField } from '../models/SourceAccountSortField';
import { SourceAccountsFilterConditions } from '../models/SourceAccountsFilterConditions';
import { SourceAwsOrganizationalUnit } from '../models/SourceAwsOrganizationalUnit';
import { SourceRegionFilters } from '../models/SourceRegionFilters';
import { SourceStorage } from '../models/SourceStorage';
import { SourceStorageBackupStatus } from '../models/SourceStorageBackupStatus';
import { SparkEngine } from '../models/SparkEngine';
import { SparkEngineStatus } from '../models/SparkEngineStatus';
import { SparkJob } from '../models/SparkJob';
import { SparkJobRetryPolicy } from '../models/SparkJobRetryPolicy';
import { SparkJobSparkSubmitParams } from '../models/SparkJobSparkSubmitParams';
import { SparkJobStatus } from '../models/SparkJobStatus';
import { SqlEngine } from '../models/SqlEngine';
import { SqlEngineStatus } from '../models/SqlEngineStatus';
import { SqlQueryExecution } from '../models/SqlQueryExecution';
import { SqlQueryExecutionResult } from '../models/SqlQueryExecutionResult';
import { SqlQueryExecutionResultColumn } from '../models/SqlQueryExecutionResultColumn';
import { SqlQueryExecutionStatus } from '../models/SqlQueryExecutionStatus';
import { SqlVmNetworkInfo } from '../models/SqlVmNetworkInfo';
import { SsoIntegrationSettings } from '../models/SsoIntegrationSettings';
import { StackNameFilters } from '../models/StackNameFilters';
import { StandardBackupPolicyPlan } from '../models/StandardBackupPolicyPlan';
import { StandardBackupScheduleConfig } from '../models/StandardBackupScheduleConfig';
import { StandardBackupScheduleFrequency } from '../models/StandardBackupScheduleFrequency';
import { StandardBackupSchedules } from '../models/StandardBackupSchedules';
import { StandardIntervalConfig, StandardIntervalConfigIntervalHoursEnum } from '../models/StandardIntervalConfig';
import { StartNotebookSessionInput } from '../models/StartNotebookSessionInput';
import { StartSparkJobInput } from '../models/StartSparkJobInput';
import { StartSqlQueryExecutionInput } from '../models/StartSqlQueryExecutionInput';
import { StartTimeDateFilters } from '../models/StartTimeDateFilters';
import { StatusCodeFilters } from '../models/StatusCodeFilters';
import { StorageAccountContainerRestoreDestination } from '../models/StorageAccountContainerRestoreDestination';
import { StorageAccountRestoreTarget } from '../models/StorageAccountRestoreTarget';
import { StorageGateway } from '../models/StorageGateway';
import { StorageGatewayDetails } from '../models/StorageGatewayDetails';
import { StorageGatewayStatus } from '../models/StorageGatewayStatus';
import { SubnetConfig, SubnetConfigModeEnum } from '../models/SubnetConfig';
import { SubnetFilters } from '../models/SubnetFilters';
import { SubnetPerAvailabilityZone } from '../models/SubnetPerAvailabilityZone';
import { SubnetsCondition } from '../models/SubnetsCondition';
import { SupportedProviders } from '../models/SupportedProviders';
import { TableRecord } from '../models/TableRecord';
import { TagKeyValue } from '../models/TagKeyValue';
import { TagKeyValuesCondition } from '../models/TagKeyValuesCondition';
import { TagKeyValuesFilters } from '../models/TagKeyValuesFilters';
import { TagKeysCondition } from '../models/TagKeysCondition';
import { TagKeysFilters } from '../models/TagKeysFilters';
import { TakeNativeSnapshotRequest } from '../models/TakeNativeSnapshotRequest';
import { TakeSnapshotRequest } from '../models/TakeSnapshotRequest';
import { TakeSnapshotResponse } from '../models/TakeSnapshotResponse';
import { TimeFrame } from '../models/TimeFrame';
import { TimeOfDay } from '../models/TimeOfDay';
import { TimeOfYear } from '../models/TimeOfYear';
import { TokenResponse } from '../models/TokenResponse';
import { UnifiedDBRecord } from '../models/UnifiedDBRecord';
import { UnifiedDBServerRecord } from '../models/UnifiedDBServerRecord';
import { UnifiedDatabaseRecord } from '../models/UnifiedDatabaseRecord';
import { UnifiedSchemaRecord } from '../models/UnifiedSchemaRecord';
import { UnifiedTableRecord } from '../models/UnifiedTableRecord';
import { UpPulumiStacksResponse } from '../models/UpPulumiStacksResponse';
import { UpdateApiCredentialsRequest } from '../models/UpdateApiCredentialsRequest';
import { UpdateBackupPolicyRequest } from '../models/UpdateBackupPolicyRequest';
import { UpdateBackupPolicyResponse } from '../models/UpdateBackupPolicyResponse';
import { UpdateCloudResourceConfigurationRequest } from '../models/UpdateCloudResourceConfigurationRequest';
import { UpdateCloudResourceConfigurationRequestCdcBackup } from '../models/UpdateCloudResourceConfigurationRequestCdcBackup';
import { UpdateCloudResourceConfigurationRequestInventoryBackup } from '../models/UpdateCloudResourceConfigurationRequestInventoryBackup';
import { UpdateControlViolationInput } from '../models/UpdateControlViolationInput';
import { UpdateDashboardInput } from '../models/UpdateDashboardInput';
import { UpdateDlsgPolicyRequest } from '../models/UpdateDlsgPolicyRequest';
import { UpdateDlsgPolicyResponse } from '../models/UpdateDlsgPolicyResponse';
import { UpdateGraphInput, UpdateGraphInputChartTypeEnum } from '../models/UpdateGraphInput';
import { UpdateIdpGroupRequest } from '../models/UpdateIdpGroupRequest';
import { UpdateIdpGroupResponse } from '../models/UpdateIdpGroupResponse';
import { UpdateIntegrationRequest } from '../models/UpdateIntegrationRequest';
import { UpdateIntegrationResponse } from '../models/UpdateIntegrationResponse';
import { UpdateJobTemplateInput } from '../models/UpdateJobTemplateInput';
import { UpdateNotebookInput } from '../models/UpdateNotebookInput';
import { UpdateProjectConfigurationKeyRequest } from '../models/UpdateProjectConfigurationKeyRequest';
import { UpdatePulumiConfigurationRequest } from '../models/UpdatePulumiConfigurationRequest';
import { UpdateResourceSecurityScansExclusionRequest } from '../models/UpdateResourceSecurityScansExclusionRequest';
import { UpdateRestoreAccountConnectivityConfigRequest } from '../models/UpdateRestoreAccountConnectivityConfigRequest';
import { UpdateRestoreAccountConnectivityConfigResponse } from '../models/UpdateRestoreAccountConnectivityConfigResponse';
import { UpdateRoleRequest } from '../models/UpdateRoleRequest';
import { UpdateRoleResponse } from '../models/UpdateRoleResponse';
import { UpdateSamlIdentityProviderInput } from '../models/UpdateSamlIdentityProviderInput';
import { UpdateSavedQueryInput } from '../models/UpdateSavedQueryInput';
import { UpdateSessionRequest } from '../models/UpdateSessionRequest';
import { UpdateShouldFullBackupResourceRequest } from '../models/UpdateShouldFullBackupResourceRequest';
import { UpdateUserInput } from '../models/UpdateUserInput';
import { UpdateVaultRequest } from '../models/UpdateVaultRequest';
import { UpdateVaultResponse } from '../models/UpdateVaultResponse';
import { UpdateViewerRoleRequest } from '../models/UpdateViewerRoleRequest';
import { Usage } from '../models/Usage';
import { UsageUnit } from '../models/UsageUnit';
import { User } from '../models/User';
import { UserIdFilters } from '../models/UserIdFilters';
import { VNetConfig, VNetConfigModeEnum } from '../models/VNetConfig';
import { ValidateResourceConfigurationRequest } from '../models/ValidateResourceConfigurationRequest';
import { ValidateResourceConfigurationResponse } from '../models/ValidateResourceConfigurationResponse';
import { VaultFilters } from '../models/VaultFilters';
import { VaultMetadataReplicationConfig } from '../models/VaultMetadataReplicationConfig';
import { VaultNotificationArguments } from '../models/VaultNotificationArguments';
import { VaultProviderAttributes } from '../models/VaultProviderAttributes';
import { VaultProviderAttributesInput } from '../models/VaultProviderAttributesInput';
import { VaultSnapshotCount } from '../models/VaultSnapshotCount';
import { Viewer } from '../models/Viewer';
import { ViolationsDetectionNotificationArguments } from '../models/ViolationsDetectionNotificationArguments';
import { VirtualMachineRestoreDestination } from '../models/VirtualMachineRestoreDestination';
import { VisualizationHistogramSeries } from '../models/VisualizationHistogramSeries';
import { VisualizationHistogramTimePoint } from '../models/VisualizationHistogramTimePoint';
import { VisualizationLabel } from '../models/VisualizationLabel';
import { VolumeSettings } from '../models/VolumeSettings';
import { VpcCondition } from '../models/VpcCondition';
import { VpcPropertyFilters } from '../models/VpcPropertyFilters';
import { WeeklyConfig } from '../models/WeeklyConfig';
import { Workspace } from '../models/Workspace';
import { WorkspaceStatus } from '../models/WorkspaceStatus';
import { YearlySnapshotDistribution } from '../models/YearlySnapshotDistribution';

/* tslint:disable:no-unused-variable */
let primitives = [
          "string",
          "boolean",
          "double",
          "integer",
          "long",
          "float",
          "number",
          "any"
         ];

let enumsMap: Set<string> = new Set<string>([
  "AccessConditionEffect",
  "AccountInstallationMethod",
  "AccountState",
  "ActionRequiredDetails",
  "AuditLogAction",
  "AwsEbsVolumeResourceVolumeTypeEnum",
  "AwsEbsVolumeResourceStateEnum",
  "AwsFsxResourceFileSystemTypeEnum",
  "AwsFsxResourceStorageTypeEnum",
  "AwsFsxResourceLifecycleStatusEnum",
  "AwsKeyspacesResourceCdcStatusEnum",
  "AwsKeyspacesResourceCdcViewTypeEnum",
  "AwsRdsEngine",
  "AzureMarketplaceWebhookInputActionEnum",
  "AzureMarketplaceWebhookInputStatusEnum",
  "AzureMarketplaceWebhookInputOperationRequestSourceEnum",
  "AzureMarketplaceWebhookInputSubscriptionAllowedCustomerOperationsEnum",
  "AzureMarketplaceWebhookInputSubscriptionSessionModeEnum",
  "AzureMarketplaceWebhookInputSubscriptionSandboxTypeEnum",
  "AzureMarketplaceWebhookInputSubscriptionSaasSubscriptionStatusEnum",
  "AzureMarketplaceWebhookInputSubscriptionTermTermUnitEnum",
  "AzureOnboardingStatusStatusEnum",
  "AzureRestorePointDataRestorePointTypeEnum",
  "AzureVaultType",
  "BackupJobSortField",
  "BackupJobType",
  "BackupPolicyType",
  "BackupStatus",
  "BillingTransactionHistoryTransactionTypeEnum",
  "CatalogOperationRequestCatalogNameEnum",
  "CatalogOperationRequestMethodEnum",
  "CloudAccountType",
  "CloudResourceAttachmentEventType",
  "ConditionOperatorEnum",
  "CostDataGroupBy",
  "CostGranularity",
  "CostRecordMetadataType",
  "CostUnit",
  "CreateGraphInputChartTypeEnum",
  "CreateSqlEngineInputWorkerSizeEnum",
  "DBSnapshotType",
  "DashboardGraphChartTypeEnum",
  "DataClass",
  "DataTransferOperationType",
  "DayOfWeek",
  "DynamoDbBillingMode",
  "EFSRestoreDestinationPerformanceModeEnum",
  "EFSRestoreDestinationThroughputModeEnum",
  "EfsSnapshotPropertiesPerformanceModeEnum",
  "EfsSnapshotPropertiesThroughputModeEnum",
  "EksClusterStatus",
  "Environment",
  "EonAccountStatus",
  "ErrorCode",
  "FsxOntapVolumeVolumeTypeEnum",
  "FsxOntapVolumeSecurityStyleEnum",
  "GcpDiskResourceDiskTypeEnum",
  "GcpDiskResourceStatusEnum",
  "GcpNetworkType",
  "HighFrequencyBackupScheduleFrequency",
  "HighFrequencyIntervalConfigIntervalMinutesEnum",
  "IndexRestoreMode",
  "IngestionPipelineStatus",
  "IngestionSourceType",
  "IntegType",
  "JobStatus",
  "JobStepName",
  "JobStepStatus",
  "KubeAccessStatus",
  "KubernetesAccessMode",
  "ListOperators",
  "LogSourceTypeEnum",
  "LogSourceWithPolicyTypeEnum",
  "LogicalOperator",
  "MeteringDimension",
  "MinRetentionRuleFrequencyEnum",
  "NetworkInterfaceConfigModeEnum",
  "NotebookExecutionOutputTypeEnum",
  "NotebookExecutionResultStatusEnum",
  "NotebookSessionStatus",
  "NotificationPolicyTypeEnum",
  "NotificationStatus",
  "NotificationType",
  "ObjectStoreExclusionRuleStoreTypeEnum",
  "PartialRestoreType",
  "PathType",
  "PermissionCategory",
  "PermissionType",
  "PitrIntervalConfigIntervalMinutesEnum",
  "ProjectConfigurationKeyEnum",
  "Provider",
  "QueryDBRestoreDestinationType",
  "QueryDBStatus",
  "QuotaStatus",
  "ResourceSelectorMode",
  "ResourceSortField",
  "ResourceType",
  "RestoreAccountSortField",
  "RestoreJobSortField",
  "RestoreJobType",
  "RestoreMethod",
  "RestoreMethodAvailabilityReason",
  "RoleInstallationMethod",
  "ScalarOperators",
  "ScanJobType",
  "ScheduleMode",
  "ScheduleType",
  "SecurityAssignmentStatus",
  "SecurityScanConclusionEnum",
  "SecurityScanDetectorTypeEnum",
  "SecurityScanExampleTypeEnum",
  "SecurityScanResultEvidenceTypeEnum",
  "Severity",
  "SnapshotLocationSnapshotTypeEnum",
  "SnapshotSortField",
  "SnapshotStatus",
  "SortLogsByFieldEnum",
  "SortOrder",
  "SourceAccountSortField",
  "SparkEngineStatus",
  "SparkJobStatus",
  "SqlEngineStatus",
  "SqlQueryExecutionStatus",
  "StandardBackupScheduleFrequency",
  "StandardIntervalConfigIntervalHoursEnum",
  "StorageGatewayStatus",
  "SubnetConfigModeEnum",
  "UpdateGraphInputChartTypeEnum",
  "UsageUnit",
  "VNetConfigModeEnum",
  "WorkspaceStatus",
]);

let typeMap: {[index: string]: any} = {
  "AccessCondition": AccessCondition,
  "AccessConditionalExpression": AccessConditionalExpression,
  "Account": Account,
  "AccountConfigInput": AccountConfigInput,
  "AccountIdCondition": AccountIdCondition,
  "AccountIdFilters": AccountIdFilters,
  "AccountMetricsDestination": AccountMetricsDestination,
  "AccountNameFilters": AccountNameFilters,
  "AccountStatusFilters": AccountStatusFilters,
  "AccountUpdateInput": AccountUpdateInput,
  "AccountVersion": AccountVersion,
  "ActionFilters": ActionFilters,
  "ActivateGcpFolderResponse": ActivateGcpFolderResponse,
  "ActivateGcpOrganizationResponse": ActivateGcpOrganizationResponse,
  "Ami": Ami,
  "AmiBlockDevice": AmiBlockDevice,
  "AnnuallyConfig": AnnuallyConfig,
  "ApiCredentials": ApiCredentials,
  "ApiCredentialsProperties": ApiCredentialsProperties,
  "App": App,
  "AppFilters": AppFilters,
  "ApplicationOverride": ApplicationOverride,
  "AppsCondition": AppsCondition,
  "AppsDetails": AppsDetails,
  "AtlasProject": AtlasProject,
  "AtlasProjects": AtlasProjects,
  "AuditLog": AuditLog,
  "AuditLogEntitiesInner": AuditLogEntitiesInner,
  "AuditLogFilterConditions": AuditLogFilterConditions,
  "AuthResponse": AuthResponse,
  "AwsAccountConfigInput": AwsAccountConfigInput,
  "AwsAccountMetricsDestination": AwsAccountMetricsDestination,
  "AwsDatabaseDestination": AwsDatabaseDestination,
  "AwsDynamoDBDestination": AwsDynamoDBDestination,
  "AwsDynamoDbResource": AwsDynamoDbResource,
  "AwsDynamoDbSnapshotProperties": AwsDynamoDbSnapshotProperties,
  "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner,
  "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput,
  "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection,
  "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput,
  "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput": AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput,
  "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner": AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInner,
  "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner": AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner,
  "AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection": AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerProjection,
  "AwsEbsSnapshotConvertResult": AwsEbsSnapshotConvertResult,
  "AwsEbsVolumeResource": AwsEbsVolumeResource,
  "AwsEbsVolumeRestoreData": AwsEbsVolumeRestoreData,
  "AwsEbsVolumeRestoreResult": AwsEbsVolumeRestoreResult,
  "AwsEbsVolumeSnapshotProperties": AwsEbsVolumeSnapshotProperties,
  "AwsEc2AmiConvertResult": AwsEc2AmiConvertResult,
  "AwsEc2InstanceRestoreDestination": AwsEc2InstanceRestoreDestination,
  "AwsEc2InstanceRestoreResult": AwsEc2InstanceRestoreResult,
  "AwsEc2InstanceRestoreTarget": AwsEc2InstanceRestoreTarget,
  "AwsEc2Resource": AwsEc2Resource,
  "AwsEc2SnapshotProperties": AwsEc2SnapshotProperties,
  "AwsEksNamespaceResource": AwsEksNamespaceResource,
  "AwsEksNamespaceSnapshotProperties": AwsEksNamespaceSnapshotProperties,
  "AwsFsxResource": AwsFsxResource,
  "AwsKeyspacesResource": AwsKeyspacesResource,
  "AwsNativePitrBackupPolicyPlan": AwsNativePitrBackupPolicyPlan,
  "AwsNativePitrBackupResourceType": AwsNativePitrBackupResourceType,
  "AwsNativePitrConfig": AwsNativePitrConfig,
  "AwsRdsResource": AwsRdsResource,
  "AwsRdsResourceAurora": AwsRdsResourceAurora,
  "AwsRdsResourceStorageSettings": AwsRdsResourceStorageSettings,
  "AwsRestoreAccountAttributes": AwsRestoreAccountAttributes,
  "AwsRestoreAccountAttributesInput": AwsRestoreAccountAttributesInput,
  "AwsRestoreAccountConnectivityConfig": AwsRestoreAccountConnectivityConfig,
  "AwsSourceAccountAttributes": AwsSourceAccountAttributes,
  "AwsSourceAccountAttributesInput": AwsSourceAccountAttributesInput,
  "AwsVaultConfig": AwsVaultConfig,
  "AwsVaultConfigInput": AwsVaultConfigInput,
  "AwsVpcConnectivityConfig": AwsVpcConnectivityConfig,
  "AzureAccountConfigInput": AzureAccountConfigInput,
  "AzureAksNamespaceResource": AzureAksNamespaceResource,
  "AzureBackupApplicationsResponse": AzureBackupApplicationsResponse,
  "AzureConsentUrlResponse": AzureConsentUrlResponse,
  "AzureDisk": AzureDisk,
  "AzureDiskRestoreData": AzureDiskRestoreData,
  "AzureDiskRestoreDestination": AzureDiskRestoreDestination,
  "AzureDiskRestoreResult": AzureDiskRestoreResult,
  "AzureDiskSettings": AzureDiskSettings,
  "AzureDiskTarget": AzureDiskTarget,
  "AzureEonApplication": AzureEonApplication,
  "AzureListResourceGroupsResponse": AzureListResourceGroupsResponse,
  "AzureListSubscriptionsResponse": AzureListSubscriptionsResponse,
  "AzureManagementGroup": AzureManagementGroup,
  "AzureManagementGroups": AzureManagementGroups,
  "AzureMarketplaceWebhookInput": AzureMarketplaceWebhookInput,
  "AzureMarketplaceWebhookInputSubscription": AzureMarketplaceWebhookInputSubscription,
  "AzureMarketplaceWebhookInputSubscriptionBeneficiary": AzureMarketplaceWebhookInputSubscriptionBeneficiary,
  "AzureMarketplaceWebhookInputSubscriptionPurchaser": AzureMarketplaceWebhookInputSubscriptionPurchaser,
  "AzureMarketplaceWebhookInputSubscriptionTerm": AzureMarketplaceWebhookInputSubscriptionTerm,
  "AzureMssqlSnapshotProperties": AzureMssqlSnapshotProperties,
  "AzureOnboardedTenantsResponse": AzureOnboardedTenantsResponse,
  "AzureOnboardingStatus": AzureOnboardingStatus,
  "AzureResourceGroup": AzureResourceGroup,
  "AzureResourceGroups": AzureResourceGroups,
  "AzureRestoreAccountAttributes": AzureRestoreAccountAttributes,
  "AzureRestoreAccountAttributesInput": AzureRestoreAccountAttributesInput,
  "AzureRestorePointData": AzureRestorePointData,
  "AzureRestorePointSpec": AzureRestorePointSpec,
  "AzureSapHanaResource": AzureSapHanaResource,
  "AzureScanningAccountSetupStatus200Response": AzureScanningAccountSetupStatus200Response,
  "AzureSourceAccountAttributes": AzureSourceAccountAttributes,
  "AzureSourceAccountAttributesInput": AzureSourceAccountAttributesInput,
  "AzureSqlDatabaseRestoreDestination": AzureSqlDatabaseRestoreDestination,
  "AzureSqlDatabaseRestoreTarget": AzureSqlDatabaseRestoreTarget,
  "AzureStorageAccount": AzureStorageAccount,
  "AzureStorageAccounts": AzureStorageAccounts,
  "AzureSubscription": AzureSubscription,
  "AzureTenant": AzureTenant,
  "AzureVaultConfig": AzureVaultConfig,
  "AzureVaultConfigInput": AzureVaultConfigInput,
  "AzureVmInstanceRestoreDestination": AzureVmInstanceRestoreDestination,
  "AzureVmInstanceRestoreResult": AzureVmInstanceRestoreResult,
  "AzureVmInstanceRestoreTarget": AzureVmInstanceRestoreTarget,
  "AzureVmSnapshotProperties": AzureVmSnapshotProperties,
  "BackedUpByResourceType": BackedUpByResourceType,
  "BackedUpByResourceTypeDataInner": BackedUpByResourceTypeDataInner,
  "BackedUpStorageDateHistogram": BackedUpStorageDateHistogram,
  "BackupControlViolations": BackupControlViolations,
  "BackupJob": BackupJob,
  "BackupJobResponse": BackupJobResponse,
  "BackupJobTypeFilters": BackupJobTypeFilters,
  "BackupJobsFilterConditions": BackupJobsFilterConditions,
  "BackupPoliciesFilters": BackupPoliciesFilters,
  "BackupPoliciesSecurityConfig": BackupPoliciesSecurityConfig,
  "BackupPolicy": BackupPolicy,
  "BackupPolicyAppliesNotificationArguments": BackupPolicyAppliesNotificationArguments,
  "BackupPolicyConfig": BackupPolicyConfig,
  "BackupPolicyExpression": BackupPolicyExpression,
  "BackupPolicyGroupCondition": BackupPolicyGroupCondition,
  "BackupPolicyNotificationArguments": BackupPolicyNotificationArguments,
  "BackupPolicyPlan": BackupPolicyPlan,
  "BackupPolicyResourceSelector": BackupPolicyResourceSelector,
  "BackupPolicySecurityConfig": BackupPolicySecurityConfig,
  "BackupRegionsFilters": BackupRegionsFilters,
  "BackupSchedule": BackupSchedule,
  "BackupScope": BackupScope,
  "BackupScopeSummary": BackupScopeSummary,
  "BackupStatusFilters": BackupStatusFilters,
  "BackupVault": BackupVault,
  "BatchApplicationOverrides": BatchApplicationOverrides,
  "BatchOperationResponse": BatchOperationResponse,
  "BatchResourceValidationResult": BatchResourceValidationResult,
  "BatchUpdateLlgPoliciesRequest": BatchUpdateLlgPoliciesRequest,
  "BatchUpdateLlgPolicyItem": BatchUpdateLlgPolicyItem,
  "BatchValidateResourceConfigurationRequest": BatchValidateResourceConfigurationRequest,
  "BatchValidateResourceConfigurationResponse": BatchValidateResourceConfigurationResponse,
  "BigQueryDatasetDestination": BigQueryDatasetDestination,
  "BigQueryIntegrationConfig": BigQueryIntegrationConfig,
  "BillingPeriod": BillingPeriod,
  "BillingTransactionHistory": BillingTransactionHistory,
  "BooleanFilters": BooleanFilters,
  "CancelExclusionFromBackupResponse": CancelExclusionFromBackupResponse,
  "CatalogOperationRequest": CatalogOperationRequest,
  "CatalogOperationResponse": CatalogOperationResponse,
  "CheckAzureVMNameExists200Response": CheckAzureVMNameExists200Response,
  "CheckAzureVMNameExistsRequest": CheckAzureVMNameExistsRequest,
  "Classifications": Classifications,
  "CloudAccountIdFilters": CloudAccountIdFilters,
  "CloudAccountNotificationArguments": CloudAccountNotificationArguments,
  "CloudProviderCondition": CloudProviderCondition,
  "CloudProviderFilters": CloudProviderFilters,
  "CloudRegion": CloudRegion,
  "CloudResourceAttachmentEvent": CloudResourceAttachmentEvent,
  "CloudResourceConfiguration": CloudResourceConfiguration,
  "CloudResourceConfigurationCdcBackup": CloudResourceConfigurationCdcBackup,
  "CloudResourceConfigurationInventoryBackup": CloudResourceConfigurationInventoryBackup,
  "CloudResourceSecurityProperties": CloudResourceSecurityProperties,
  "CloudSnapshotsPerVolume": CloudSnapshotsPerVolume,
  "ClusterNameFilters": ClusterNameFilters,
  "ColumnMetadata": ColumnMetadata,
  "Condition": Condition,
  "ConnectAzureBackupAccountRequest": ConnectAzureBackupAccountRequest,
  "ConnectAzureBackupApplicationsRequest": ConnectAzureBackupApplicationsRequest,
  "ConnectAzureRestoreAccountRequest": ConnectAzureRestoreAccountRequest,
  "ConnectAzureSourceAccountRequest": ConnectAzureSourceAccountRequest,
  "ConnectAzureVaultAccountRequest": ConnectAzureVaultAccountRequest,
  "ConnectBYOAzureBackupApplicationsRequest": ConnectBYOAzureBackupApplicationsRequest,
  "ConnectCustomerVaultAccountRequest": ConnectCustomerVaultAccountRequest,
  "ConnectCustomerVaultAccountResponse": ConnectCustomerVaultAccountResponse,
  "ConnectGcpFolderRequest": ConnectGcpFolderRequest,
  "ConnectGcpFolderResponse": ConnectGcpFolderResponse,
  "ConnectGcpOrganizationRequest": ConnectGcpOrganizationRequest,
  "ConnectGcpOrganizationResponse": ConnectGcpOrganizationResponse,
  "ConnectRestoreAccountRequest": ConnectRestoreAccountRequest,
  "ConnectRestoreAccountResponse": ConnectRestoreAccountResponse,
  "ConnectSourceAccountRequest": ConnectSourceAccountRequest,
  "ConnectSourceAccountResponse": ConnectSourceAccountResponse,
  "ConnectSourceAwsOrganizationalUnitRequest": ConnectSourceAwsOrganizationalUnitRequest,
  "ConnectSourceAwsOrganizationalUnitResponse": ConnectSourceAwsOrganizationalUnitResponse,
  "Control": Control,
  "ControlRules": ControlRules,
  "ControlViolation": ControlViolation,
  "ControlViolations": ControlViolations,
  "ControlViolationsPerSeverity": ControlViolationsPerSeverity,
  "ControlViolationsPerSeverityViolatedControlsInner": ControlViolationsPerSeverityViolatedControlsInner,
  "ControlsFilters": ControlsFilters,
  "ConvertEbsSnapshotConfig": ConvertEbsSnapshotConfig,
  "ConvertEc2ImageConfig": ConvertEc2ImageConfig,
  "ConvertOtherSnapshotsOnDemandRequest": ConvertOtherSnapshotsOnDemandRequest,
  "ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner": ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner,
  "ConvertResourceSnapshotsRequest": ConvertResourceSnapshotsRequest,
  "ConvertResourceSnapshotsResponse": ConvertResourceSnapshotsResponse,
  "Cost": Cost,
  "CostDataFilters": CostDataFilters,
  "CostDataRecord": CostDataRecord,
  "CostDataRecordCost": CostDataRecordCost,
  "CostDataRecordDimensions": CostDataRecordDimensions,
  "CostRecordMetadata": CostRecordMetadata,
  "CostRecordMetadataDataTransfer": CostRecordMetadataDataTransfer,
  "CreateAccountInput": CreateAccountInput,
  "CreateApiCredentialsRequest": CreateApiCredentialsRequest,
  "CreateApiCredentialsResponse": CreateApiCredentialsResponse,
  "CreateBackupPolicyRequest": CreateBackupPolicyRequest,
  "CreateBackupPolicyResponse": CreateBackupPolicyResponse,
  "CreateDashboardInput": CreateDashboardInput,
  "CreateDlsgPolicyRequest": CreateDlsgPolicyRequest,
  "CreateDlsgPolicyResponse": CreateDlsgPolicyResponse,
  "CreateFabricTableShortcutDemoRequest": CreateFabricTableShortcutDemoRequest,
  "CreateFabricTableShortcutDemoRequestShortcutsInner": CreateFabricTableShortcutDemoRequestShortcutsInner,
  "CreateFabricTableShortcutDemoResponse": CreateFabricTableShortcutDemoResponse,
  "CreateFabricTableShortcutDemoResponseResultsInner": CreateFabricTableShortcutDemoResponseResultsInner,
  "CreateGraphInput": CreateGraphInput,
  "CreateIdpGroupRequest": CreateIdpGroupRequest,
  "CreateIdpGroupResponse": CreateIdpGroupResponse,
  "CreateInfectedExcludePathInput": CreateInfectedExcludePathInput,
  "CreateIngestionPipelineInput": CreateIngestionPipelineInput,
  "CreateIntegrationRequest": CreateIntegrationRequest,
  "CreateIntegrationResponse": CreateIntegrationResponse,
  "CreateJobTemplateInput": CreateJobTemplateInput,
  "CreateNotebookInput": CreateNotebookInput,
  "CreatePolicyInput": CreatePolicyInput,
  "CreatePolicyScheduleInput": CreatePolicyScheduleInput,
  "CreateProjectInput": CreateProjectInput,
  "CreatePulumiConfigurationRequest": CreatePulumiConfigurationRequest,
  "CreateRoleRequest": CreateRoleRequest,
  "CreateRoleResponse": CreateRoleResponse,
  "CreateSamlIdentityProviderConfigInput": CreateSamlIdentityProviderConfigInput,
  "CreateSavedQueryInput": CreateSavedQueryInput,
  "CreateScanJobInput": CreateScanJobInput,
  "CreateScanJobResponse": CreateScanJobResponse,
  "CreateSessionRequest": CreateSessionRequest,
  "CreateSparkEngineInput": CreateSparkEngineInput,
  "CreateSqlEngineInput": CreateSqlEngineInput,
  "CreateUserInput": CreateUserInput,
  "CreateVaultRequest": CreateVaultRequest,
  "CreateVaultResponse": CreateVaultResponse,
  "CrossResourceQueryRequest": CrossResourceQueryRequest,
  "CrossResourceQueryRequestResourcesInner": CrossResourceQueryRequestResourcesInner,
  "CustomTagsInner": CustomTagsInner,
  "CustomerVaultAccount": CustomerVaultAccount,
  "DBResourceMetadata": DBResourceMetadata,
  "DBServerRecord": DBServerRecord,
  "DBSnapshotMetadata": DBSnapshotMetadata,
  "DailyConfig": DailyConfig,
  "DailySnapshotData": DailySnapshotData,
  "DailyStorageSummaries": DailyStorageSummaries,
  "DailyStorageSummary": DailyStorageSummary,
  "Dashboard": Dashboard,
  "DashboardGraph": DashboardGraph,
  "DashboardGraphLayout": DashboardGraphLayout,
  "DashboardWithGraphs": DashboardWithGraphs,
  "DataClassesCondition": DataClassesCondition,
  "DataClassesDetails": DataClassesDetails,
  "DataClassesFilters": DataClassesFilters,
  "DataClassificationEntity": DataClassificationEntity,
  "DataShareIntegrationConfig": DataShareIntegrationConfig,
  "DatabaseDestination": DatabaseDestination,
  "DatabaseRecord": DatabaseRecord,
  "DatabricksIntegrationConfig": DatabricksIntegrationConfig,
  "DeactivateAccountRequest": DeactivateAccountRequest,
  "DeactivateAccountResponse": DeactivateAccountResponse,
  "DeactivateGcpFolderResponse": DeactivateGcpFolderResponse,
  "DeactivateGcpOrganizationResponse": DeactivateGcpOrganizationResponse,
  "DestinationDetails": DestinationDetails,
  "DestinationProviderAttributes": DestinationProviderAttributes,
  "DestinationProviderAttributesAzure": DestinationProviderAttributesAzure,
  "DestinationRestoreTypeAttributes": DestinationRestoreTypeAttributes,
  "DisableResourceOverrideLimitsResponse": DisableResourceOverrideLimitsResponse,
  "DisconnectCustomerVaultAccountResponse": DisconnectCustomerVaultAccountResponse,
  "DisconnectRestoreAccountResponse": DisconnectRestoreAccountResponse,
  "DisconnectSourceAccountResponse": DisconnectSourceAccountResponse,
  "DisconnectSourceAwsOrganizationalUnitResponse": DisconnectSourceAwsOrganizationalUnitResponse,
  "DiscoveryInvokeParams": DiscoveryInvokeParams,
  "DiscoveryJob": DiscoveryJob,
  "DiscoveryStatusResponse": DiscoveryStatusResponse,
  "DlsgPolicy": DlsgPolicy,
  "DlsgPolicyConfig": DlsgPolicyConfig,
  "DlsgPolicyFilters": DlsgPolicyFilters,
  "DlsgPolicyPlan": DlsgPolicyPlan,
  "DlsgSettings": DlsgSettings,
  "DriftProtectionPolicy": DriftProtectionPolicy,
  "DriftProtectionSummary": DriftProtectionSummary,
  "DriftProtectionTimePoint": DriftProtectionTimePoint,
  "DynamoDBAdvancedIndexConfig": DynamoDBAdvancedIndexConfig,
  "DynamoDBRestoreMethodAvailabilityRequest": DynamoDBRestoreMethodAvailabilityRequest,
  "DynamoDBRestoreMethodAvailabilityResponse": DynamoDBRestoreMethodAvailabilityResponse,
  "DynamoDbBackupConfig": DynamoDbBackupConfig,
  "DynamoDbBackupConfigApplication": DynamoDbBackupConfigApplication,
  "DynamodbTableRestoreDestination": DynamodbTableRestoreDestination,
  "EFSRestoreDestination": EFSRestoreDestination,
  "EbsRestoreDestination": EbsRestoreDestination,
  "EbsSnapshotRestoreDestination": EbsSnapshotRestoreDestination,
  "EbsSnapshotTarget": EbsSnapshotTarget,
  "EbsTarget": EbsTarget,
  "EfsSnapshotProperties": EfsSnapshotProperties,
  "EksCluster": EksCluster,
  "EksNamespaceRestoreDestination": EksNamespaceRestoreDestination,
  "EksNamespaceRestoreResult": EksNamespaceRestoreResult,
  "EksVolumeRestoreResult": EksVolumeRestoreResult,
  "EmrIntegrationConfig": EmrIntegrationConfig,
  "EnableFromLimitExceededResponse": EnableFromLimitExceededResponse,
  "EnableResourceOverrideLimitsResponse": EnableResourceOverrideLimitsResponse,
  "EnableRestoreAccountMetricsConfigRequest": EnableRestoreAccountMetricsConfigRequest,
  "EnableRestoreAccountMetricsConfigResponse": EnableRestoreAccountMetricsConfigResponse,
  "EnableSourceAccountMetricsConfigRequest": EnableSourceAccountMetricsConfigRequest,
  "EnableSourceAccountMetricsConfigResponse": EnableSourceAccountMetricsConfigResponse,
  "EncryptionKey": EncryptionKey,
  "EncryptionKeys": EncryptionKeys,
  "EndTimeDateFilters": EndTimeDateFilters,
  "EnvironmentCondition": EnvironmentCondition,
  "EnvironmentDetails": EnvironmentDetails,
  "EnvironmentFilters": EnvironmentFilters,
  "EonAccount": EonAccount,
  "EonAccountIdFilters": EonAccountIdFilters,
  "ExcludeFromBackupResponse": ExcludeFromBackupResponse,
  "ExecuteNotebookCodeInput": ExecuteNotebookCodeInput,
  "ExportCostData400Response": ExportCostData400Response,
  "ExportCostDataRequest": ExportCostDataRequest,
  "FSxRestoreDestination": FSxRestoreDestination,
  "FSxRestoreDestinationOntapRestoreOptions": FSxRestoreDestinationOntapRestoreOptions,
  "FileExplorerCountSecurityAlertsInResourceResponse": FileExplorerCountSecurityAlertsInResourceResponse,
  "FileExplorerResponse": FileExplorerResponse,
  "FilePath": FilePath,
  "FileRestoreData": FileRestoreData,
  "FileSearchRecord": FileSearchRecord,
  "FileSnapshot": FileSnapshot,
  "ForceDeleteSnapshotsRequest": ForceDeleteSnapshotsRequest,
  "FreeTextFilters": FreeTextFilters,
  "FsxBackupData": FsxBackupData,
  "FsxOntapVolume": FsxOntapVolume,
  "FsxSnapshotProperties": FsxSnapshotProperties,
  "FsxVolumeBackupInfo": FsxVolumeBackupInfo,
  "GCSBucket": GCSBucket,
  "GCSBuckets": GCSBuckets,
  "GCSRestoreDestination": GCSRestoreDestination,
  "GCSRestoreTarget": GCSRestoreTarget,
  "GcpAccountConfigInput": GcpAccountConfigInput,
  "GcpBigQueryResource": GcpBigQueryResource,
  "GcpBigQueryResourceMaterializedViewsInner": GcpBigQueryResourceMaterializedViewsInner,
  "GcpBigQueryResourceRoutinesInner": GcpBigQueryResourceRoutinesInner,
  "GcpBigQueryResourceTablesInner": GcpBigQueryResourceTablesInner,
  "GcpBigQueryResourceViewsInner": GcpBigQueryResourceViewsInner,
  "GcpCloudSqlResource": GcpCloudSqlResource,
  "GcpCloudSqlResourceStorageSettings": GcpCloudSqlResourceStorageSettings,
  "GcpCloudSqlRestoreDestination": GcpCloudSqlRestoreDestination,
  "GcpCloudSqlSnapshotProperties": GcpCloudSqlSnapshotProperties,
  "GcpCloudSqlTarget": GcpCloudSqlTarget,
  "GcpDiskResource": GcpDiskResource,
  "GcpDiskRestoreData": GcpDiskRestoreData,
  "GcpDiskRestoreDestination": GcpDiskRestoreDestination,
  "GcpDiskSettings": GcpDiskSettings,
  "GcpDiskSnapshotProperties": GcpDiskSnapshotProperties,
  "GcpDiskTarget": GcpDiskTarget,
  "GcpDiskTypesResponse": GcpDiskTypesResponse,
  "GcpEncryptionKey": GcpEncryptionKey,
  "GcpEncryptionKeys": GcpEncryptionKeys,
  "GcpGkeNamespaceResource": GcpGkeNamespaceResource,
  "GcpMachineTypesResponse": GcpMachineTypesResponse,
  "GcpNetworkConnectivityConfig": GcpNetworkConnectivityConfig,
  "GcpOrganization": GcpOrganization,
  "GcpRestoreAccountAttributes": GcpRestoreAccountAttributes,
  "GcpRestoreAccountAttributesInput": GcpRestoreAccountAttributesInput,
  "GcpRestoreAccountConnectivityConfig": GcpRestoreAccountConnectivityConfig,
  "GcpSourceAccountAttributes": GcpSourceAccountAttributes,
  "GcpSourceAccountAttributesInput": GcpSourceAccountAttributesInput,
  "GcpSubnet": GcpSubnet,
  "GcpSubnetPerRegion": GcpSubnetPerRegion,
  "GcpVaultConfig": GcpVaultConfig,
  "GcpVaultConfigInput": GcpVaultConfigInput,
  "GcpVmInstanceRestoreDestination": GcpVmInstanceRestoreDestination,
  "GcpVmInstanceRestoreTarget": GcpVmInstanceRestoreTarget,
  "GcpVmResource": GcpVmResource,
  "GcpVmSnapshotProperties": GcpVmSnapshotProperties,
  "GenericSnapshotData": GenericSnapshotData,
  "GetAWSStackDetailsResponse": GetAWSStackDetailsResponse,
  "GetBackupJobResponse": GetBackupJobResponse,
  "GetBackupPolicyResponse": GetBackupPolicyResponse,
  "GetBillingPeriodsResponse": GetBillingPeriodsResponse,
  "GetBillingTransactionHistoryRequest": GetBillingTransactionHistoryRequest,
  "GetBillingTransactionHistoryResponse": GetBillingTransactionHistoryResponse,
  "GetCloudResourceSecurityPropertiesResponse": GetCloudResourceSecurityPropertiesResponse,
  "GetCredits400Response": GetCredits400Response,
  "GetCreditsResponse": GetCreditsResponse,
  "GetDlsgPolicyResponse": GetDlsgPolicyResponse,
  "GetGcsServiceAgentResponse": GetGcsServiceAgentResponse,
  "GetIdpGroupResponse": GetIdpGroupResponse,
  "GetIntegrationResponse": GetIntegrationResponse,
  "GetLimitsResponseValue": GetLimitsResponseValue,
  "GetNotebookContent200Response": GetNotebookContent200Response,
  "GetProjectConfigurationKeyResponse": GetProjectConfigurationKeyResponse,
  "GetProjectConfigurationKeysResponse": GetProjectConfigurationKeysResponse,
  "GetResourceResponse": GetResourceResponse,
  "GetRestoreAccountConnectivityConfigResponse": GetRestoreAccountConnectivityConfigResponse,
  "GetRestoreAccountMetricsConfigResponse": GetRestoreAccountMetricsConfigResponse,
  "GetRestoreJobResponse": GetRestoreJobResponse,
  "GetRoleResponse": GetRoleResponse,
  "GetScanJobResponse": GetScanJobResponse,
  "GetSnapshotResponse": GetSnapshotResponse,
  "GetSourceAccountMetricsConfigResponse": GetSourceAccountMetricsConfigResponse,
  "GetSqlVmNetworkInfoRequest": GetSqlVmNetworkInfoRequest,
  "GetSqlVmNetworkInfoResponse": GetSqlVmNetworkInfoResponse,
  "GetVaultResponse": GetVaultResponse,
  "GroupToRoleMapping": GroupToRoleMapping,
  "HighFrequencyBackupPolicyPlan": HighFrequencyBackupPolicyPlan,
  "HighFrequencyBackupResourceType": HighFrequencyBackupResourceType,
  "HighFrequencyBackupScheduleConfig": HighFrequencyBackupScheduleConfig,
  "HighFrequencyBackupSchedules": HighFrequencyBackupSchedules,
  "HighFrequencyIntervalConfig": HighFrequencyIntervalConfig,
  "IDs": IDs,
  "IdFilters": IdFilters,
  "Identifier": Identifier,
  "IdentityProvidersNames": IdentityProvidersNames,
  "Idp": Idp,
  "IdpGroup": IdpGroup,
  "ImportDlsgCertificateRequest": ImportDlsgCertificateRequest,
  "InfectedDataByClassification": InfectedDataByClassification,
  "InfectedDataClassificationSize": InfectedDataClassificationSize,
  "InfectedDataOverTime": InfectedDataOverTime,
  "InfectedDateSize": InfectedDateSize,
  "InfectedExcludePath": InfectedExcludePath,
  "InfectedResourcesCountResponse": InfectedResourcesCountResponse,
  "IngestionPipeline": IngestionPipeline,
  "InitAuthInput": InitAuthInput,
  "Initiator": Initiator,
  "InitiatorNameFilters": InitiatorNameFilters,
  "IntegConfig": IntegConfig,
  "IntegrationConfig": IntegrationConfig,
  "InventoryFilterConditions": InventoryFilterConditions,
  "InventoryGcpDisk": InventoryGcpDisk,
  "InventoryResource": InventoryResource,
  "InventoryResourceMetadata": InventoryResourceMetadata,
  "InventorySnapshotVolume": InventorySnapshotVolume,
  "InventoryVault": InventoryVault,
  "InventoryVolume": InventoryVolume,
  "IssueMutedNotificationArguments": IssueMutedNotificationArguments,
  "JobExecutionDetails": JobExecutionDetails,
  "JobFailedNotificationArguments": JobFailedNotificationArguments,
  "JobIdFilters": JobIdFilters,
  "JobInitiationResponse": JobInitiationResponse,
  "JobMetricsReportFailedArguments": JobMetricsReportFailedArguments,
  "JobSnapshotDetails": JobSnapshotDetails,
  "JobStatusFilters": JobStatusFilters,
  "JobStep": JobStep,
  "JobSucceededNotificationArguments": JobSucceededNotificationArguments,
  "JobTemplate": JobTemplate,
  "LimitData": LimitData,
  "ListAccountsResponse": ListAccountsResponse,
  "ListApiCredentialsResponse": ListApiCredentialsResponse,
  "ListApplicationOverrideResponse": ListApplicationOverrideResponse,
  "ListAuditLogRequest": ListAuditLogRequest,
  "ListAuditLogResponse": ListAuditLogResponse,
  "ListAuditLogsResponse": ListAuditLogsResponse,
  "ListAzureRegions200Response": ListAzureRegions200Response,
  "ListAzureSKUs200Response": ListAzureSKUs200Response,
  "ListAzureSKUs200ResponseSkusInner": ListAzureSKUs200ResponseSkusInner,
  "ListAzureSKUsRequest": ListAzureSKUsRequest,
  "ListAzureStorageAccountContainers200Response": ListAzureStorageAccountContainers200Response,
  "ListAzureStorageAccountContainersRequest": ListAzureStorageAccountContainersRequest,
  "ListAzureSubnets200Response": ListAzureSubnets200Response,
  "ListAzureSubnets200ResponseSubnetsInner": ListAzureSubnets200ResponseSubnetsInner,
  "ListAzureSubnetsRequest": ListAzureSubnetsRequest,
  "ListAzureUnassignedNetworkInterfaces200Response": ListAzureUnassignedNetworkInterfaces200Response,
  "ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner": ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner,
  "ListAzureUnassignedNetworkInterfacesRequest": ListAzureUnassignedNetworkInterfacesRequest,
  "ListAzureVirtualNetworks200Response": ListAzureVirtualNetworks200Response,
  "ListAzureVirtualNetworks200ResponseVirtualNetworksInner": ListAzureVirtualNetworks200ResponseVirtualNetworksInner,
  "ListAzureVirtualNetworksRequest": ListAzureVirtualNetworksRequest,
  "ListBackupJobTypesResponse": ListBackupJobTypesResponse,
  "ListBackupJobsInternal200Response": ListBackupJobsInternal200Response,
  "ListBackupJobsRequest": ListBackupJobsRequest,
  "ListBackupJobsResponse": ListBackupJobsResponse,
  "ListBackupPoliciesResponse": ListBackupPoliciesResponse,
  "ListBackupPolicyResponse": ListBackupPolicyResponse,
  "ListBackupVaultResponse": ListBackupVaultResponse,
  "ListCloudSnapshotsResponse": ListCloudSnapshotsResponse,
  "ListControlViolationsResponse": ListControlViolationsResponse,
  "ListControlsResponse": ListControlsResponse,
  "ListDailySnapshotsResponse": ListDailySnapshotsResponse,
  "ListDashboardsResponse": ListDashboardsResponse,
  "ListDataClassificationEntitiesResponse": ListDataClassificationEntitiesResponse,
  "ListDatabaseSnapshotsResponse": ListDatabaseSnapshotsResponse,
  "ListDlsgPoliciesResponse": ListDlsgPoliciesResponse,
  "ListDynamoDbBackupConfigsResponse": ListDynamoDbBackupConfigsResponse,
  "ListEksClustersResponse": ListEksClustersResponse,
  "ListGcpFoldersResponse": ListGcpFoldersResponse,
  "ListGcpNetworksResponse": ListGcpNetworksResponse,
  "ListGcpNetworksResponseNetworksInner": ListGcpNetworksResponseNetworksInner,
  "ListGcpOrganizationsResponse": ListGcpOrganizationsResponse,
  "ListGcpSubnetsResponse": ListGcpSubnetsResponse,
  "ListIdpGroupsResponse": ListIdpGroupsResponse,
  "ListIdpsResponse": ListIdpsResponse,
  "ListInfectedExcludePathsResponse": ListInfectedExcludePathsResponse,
  "ListIngestionPipelinesResponse": ListIngestionPipelinesResponse,
  "ListInstanceProfilesResponse": ListInstanceProfilesResponse,
  "ListInstanceTypesResponse": ListInstanceTypesResponse,
  "ListIntegrationsResponse": ListIntegrationsResponse,
  "ListInventoryAppsResponse": ListInventoryAppsResponse,
  "ListInventoryBackupRegionsResponse": ListInventoryBackupRegionsResponse,
  "ListInventoryEnvironmentsResponse": ListInventoryEnvironmentsResponse,
  "ListInventoryGlobalDatabasesResponse": ListInventoryGlobalDatabasesResponse,
  "ListInventoryItemSnapshotsResponse": ListInventoryItemSnapshotsResponse,
  "ListInventoryNetworksResponse": ListInventoryNetworksResponse,
  "ListInventoryRequest": ListInventoryRequest,
  "ListInventoryResourceGroupsResponse": ListInventoryResourceGroupsResponse,
  "ListInventoryResourceIdentifiersResponse": ListInventoryResourceIdentifiersResponse,
  "ListInventoryResourceTypesResponse": ListInventoryResourceTypesResponse,
  "ListInventoryResourcesResponse": ListInventoryResourcesResponse,
  "ListInventorySnapshotsRequest": ListInventorySnapshotsRequest,
  "ListInventorySnapshotsResponse": ListInventorySnapshotsResponse,
  "ListInventorySourceRegionsResponse": ListInventorySourceRegionsResponse,
  "ListInventorySubnetsResponse": ListInventorySubnetsResponse,
  "ListInventoryTagsResponse": ListInventoryTagsResponse,
  "ListJobErrorCodesResponse": ListJobErrorCodesResponse,
  "ListJobTemplatesResponse": ListJobTemplatesResponse,
  "ListKnownAppsResponse": ListKnownAppsResponse,
  "ListLogSourcesPoliciesResponse": ListLogSourcesPoliciesResponse,
  "ListLogSourcesResponse": ListLogSourcesResponse,
  "ListNotebooksResponse": ListNotebooksResponse,
  "ListNotificationPoliciesResponse": ListNotificationPoliciesResponse,
  "ListNotificationsResponse": ListNotificationsResponse,
  "ListObjectStoreExclusionRulesResponse": ListObjectStoreExclusionRulesResponse,
  "ListPermissionsResponse": ListPermissionsResponse,
  "ListProjectsResponse": ListProjectsResponse,
  "ListResourceAttachmentEventsResponse": ListResourceAttachmentEventsResponse,
  "ListResourcesResponse": ListResourcesResponse,
  "ListRestoreAccountsRequest": ListRestoreAccountsRequest,
  "ListRestoreAccountsResponse": ListRestoreAccountsResponse,
  "ListRestoreJobTypesResponse": ListRestoreJobTypesResponse,
  "ListRestoreJobsInternal200Response": ListRestoreJobsInternal200Response,
  "ListRestoreJobsRequest": ListRestoreJobsRequest,
  "ListRestoreJobsResponse": ListRestoreJobsResponse,
  "ListRolesResponse": ListRolesResponse,
  "ListSavedQueriesResponse": ListSavedQueriesResponse,
  "ListScanJobTypesResponse": ListScanJobTypesResponse,
  "ListScanJobsInternal200Response": ListScanJobsInternal200Response,
  "ListScanJobsRequest": ListScanJobsRequest,
  "ListScanJobsResponse": ListScanJobsResponse,
  "ListSensitivityAnnotationsResponse": ListSensitivityAnnotationsResponse,
  "ListSourceAccountsRequest": ListSourceAccountsRequest,
  "ListSourceAccountsResponse": ListSourceAccountsResponse,
  "ListSourceAwsOrganizationalUnitsResponse": ListSourceAwsOrganizationalUnitsResponse,
  "ListSparkEnginesResponse": ListSparkEnginesResponse,
  "ListSparkJobsResponse": ListSparkJobsResponse,
  "ListSqlEnginesResponse": ListSqlEnginesResponse,
  "ListSqlQueryExecutionsResponse": ListSqlQueryExecutionsResponse,
  "ListStorageGatewaysResponse": ListStorageGatewaysResponse,
  "ListSubnetsResponse": ListSubnetsResponse,
  "ListSubnetsResponseV2": ListSubnetsResponseV2,
  "ListSubnetsResponseV2SubnetsInner": ListSubnetsResponseV2SubnetsInner,
  "ListUsersResponse": ListUsersResponse,
  "LlgLocationResource": LlgLocationResource,
  "LlgLocationWithResources": LlgLocationWithResources,
  "LlgResourcePolicy": LlgResourcePolicy,
  "LogRecord": LogRecord,
  "LogSource": LogSource,
  "LogSourceLocation": LogSourceLocation,
  "LogSourceLocationCloudTrail": LogSourceLocationCloudTrail,
  "LogSourceLocationCloudWatchLogs": LogSourceLocationCloudWatchLogs,
  "LogSourceLocationDatadog": LogSourceLocationDatadog,
  "LogSourceLocationSplunkDdss": LogSourceLocationSplunkDdss,
  "LogSourceWithPolicy": LogSourceWithPolicy,
  "LogsHistogramDataPoint": LogsHistogramDataPoint,
  "LogsSchema": LogsSchema,
  "LogsSchemaColumn": LogsSchemaColumn,
  "LogsSchemaEntry": LogsSchemaEntry,
  "LogsSchemasResponse": LogsSchemasResponse,
  "LuceneQueryInput": LuceneQueryInput,
  "MaxRetentionRule": MaxRetentionRule,
  "Message": Message,
  "MicrosoftFabricIntegrationConfig": MicrosoftFabricIntegrationConfig,
  "MinRetentionRule": MinRetentionRule,
  "ModelError": ModelError,
  "MonthlyConfig": MonthlyConfig,
  "MonthlySnapshotData": MonthlySnapshotData,
  "MsaAcceptanceResponse": MsaAcceptanceResponse,
  "NativeStandardBackupPolicyPlan": NativeStandardBackupPolicyPlan,
  "NativeStandardBackupSchedules": NativeStandardBackupSchedules,
  "NetworkInterfaceConfig": NetworkInterfaceConfig,
  "Notebook": Notebook,
  "NotebookExecutionOutput": NotebookExecutionOutput,
  "NotebookExecutionResult": NotebookExecutionResult,
  "NotebookSession": NotebookSession,
  "Notification": Notification,
  "NotificationArguments": NotificationArguments,
  "NotificationPolicy": NotificationPolicy,
  "NotificationPolicyConfig": NotificationPolicyConfig,
  "NotificationPolicyConfigEmail": NotificationPolicyConfigEmail,
  "NotificationPolicyConfigServiceNow": NotificationPolicyConfigServiceNow,
  "NotificationPolicyConfigSlack": NotificationPolicyConfigSlack,
  "NotificationPolicyConfigSns": NotificationPolicyConfigSns,
  "NotificationPolicyConfigSplunk": NotificationPolicyConfigSplunk,
  "NotificationPolicyConfigWebhook": NotificationPolicyConfigWebhook,
  "NumberOfCopiesRule": NumberOfCopiesRule,
  "Oauth2TokenResponse": Oauth2TokenResponse,
  "ObjectStorageDestination": ObjectStorageDestination,
  "ObjectStoreExclusionRule": ObjectStoreExclusionRule,
  "OnboardingAzureResourceGroup": OnboardingAzureResourceGroup,
  "OperationIdFilters": OperationIdFilters,
  "OrganizationIdFilters": OrganizationIdFilters,
  "OverrideDataClassificationsRequest": OverrideDataClassificationsRequest,
  "OverrideDataClassificationsResponse": OverrideDataClassificationsResponse,
  "OverrideEnvironmentRequest": OverrideEnvironmentRequest,
  "OverrideEnvironmentResponse": OverrideEnvironmentResponse,
  "Pagination": Pagination,
  "PartialRestoreData": PartialRestoreData,
  "Path": Path,
  "PathSnapshotsRequest": PathSnapshotsRequest,
  "PathSnapshotsResponse": PathSnapshotsResponse,
  "Permission": Permission,
  "PermissionGrant": PermissionGrant,
  "PermissionGrantInput": PermissionGrantInput,
  "PersistentVolumeClaimProperties": PersistentVolumeClaimProperties,
  "PitrBackupPolicyPlan": PitrBackupPolicyPlan,
  "PitrBackupResourceType": PitrBackupResourceType,
  "PitrBackupSchedules": PitrBackupSchedules,
  "PitrIntervalConfig": PitrIntervalConfig,
  "PitrRestoreVaultWindows": PitrRestoreVaultWindows,
  "PitrRestoreWindow": PitrRestoreWindow,
  "PitrRestoreWindowsResponse": PitrRestoreWindowsResponse,
  "Preferences": Preferences,
  "Project": Project,
  "ProjectIdFilters": ProjectIdFilters,
  "ProviderAccountIdFilters": ProviderAccountIdFilters,
  "ProviderOrganizationIdFilters": ProviderOrganizationIdFilters,
  "ProviderRestoreAccountConnectivityConfig": ProviderRestoreAccountConnectivityConfig,
  "PulumiConfiguration": PulumiConfiguration,
  "PulumiConfigurations": PulumiConfigurations,
  "PulumiConfigurationsFilterConditions": PulumiConfigurationsFilterConditions,
  "PulumiConfigurationsRequest": PulumiConfigurationsRequest,
  "QueryCostData400Response": QueryCostData400Response,
  "QueryCostDataRequest": QueryCostDataRequest,
  "QueryCostDataResponse": QueryCostDataResponse,
  "QueryDBRequest": QueryDBRequest,
  "QueryDBResponse": QueryDBResponse,
  "QueryDBRestoreDestination": QueryDBRestoreDestination,
  "QueryDBResultResponse": QueryDBResultResponse,
  "QueryDBStatusResponse": QueryDBStatusResponse,
  "QuotaStatusFilters": QuotaStatusFilters,
  "RansomwareResourceNotificationArguments": RansomwareResourceNotificationArguments,
  "RansomwareSnapshotNotificationArguments": RansomwareSnapshotNotificationArguments,
  "RdsNativePitrAdvancedConfig": RdsNativePitrAdvancedConfig,
  "RdsNativePitrClusterAdvancedConfig": RdsNativePitrClusterAdvancedConfig,
  "RdsNativePitrNetworkConfig": RdsNativePitrNetworkConfig,
  "RdsNativePitrWindow": RdsNativePitrWindow,
  "ReactivateAccountRequest": ReactivateAccountRequest,
  "ReconnectCustomerVaultAccountResponse": ReconnectCustomerVaultAccountResponse,
  "ReconnectRestoreAccountResponse": ReconnectRestoreAccountResponse,
  "ReconnectSourceAccountResponse": ReconnectSourceAccountResponse,
  "ReconnectSourceAwsOrganizationalUnitResponse": ReconnectSourceAwsOrganizationalUnitResponse,
  "RecordRestoreResult": RecordRestoreResult,
  "RedshiftCluster": RedshiftCluster,
  "RedshiftClusters": RedshiftClusters,
  "RedshiftIntegrationConfig": RedshiftIntegrationConfig,
  "RegionCondition": RegionCondition,
  "RegisterInput": RegisterInput,
  "RegisterInputBillingToken": RegisterInputBillingToken,
  "RegisterResponse": RegisterResponse,
  "RelatedGlobalDbCluster": RelatedGlobalDbCluster,
  "RequestDetails": RequestDetails,
  "ResourceDetails": ResourceDetails,
  "ResourceGroupNameCondition": ResourceGroupNameCondition,
  "ResourceIdCondition": ResourceIdCondition,
  "ResourceIdFilters": ResourceIdFilters,
  "ResourceIdentifiers": ResourceIdentifiers,
  "ResourceNameCondition": ResourceNameCondition,
  "ResourceNameFilters": ResourceNameFilters,
  "ResourceProperties": ResourceProperties,
  "ResourceSnapshot": ResourceSnapshot,
  "ResourceSnapshotProperties": ResourceSnapshotProperties,
  "ResourceTag": ResourceTag,
  "ResourceTypeCondition": ResourceTypeCondition,
  "ResourceTypeFilters": ResourceTypeFilters,
  "ResourceTypeToSecurityGroup": ResourceTypeToSecurityGroup,
  "ResourceValidationError": ResourceValidationError,
  "RestoreAccount": RestoreAccount,
  "RestoreAccountAttributesInput": RestoreAccountAttributesInput,
  "RestoreAccountCloudAttributes": RestoreAccountCloudAttributes,
  "RestoreAccountConnectivityConfig": RestoreAccountConnectivityConfig,
  "RestoreAccountMetricsConfig": RestoreAccountMetricsConfig,
  "RestoreAccountRegions": RestoreAccountRegions,
  "RestoreAccountsFilterConditions": RestoreAccountsFilterConditions,
  "RestoreAtlasClusterInput": RestoreAtlasClusterInput,
  "RestoreAvailabilityZones": RestoreAvailabilityZones,
  "RestoreAwsEc2InstanceRequest": RestoreAwsEc2InstanceRequest,
  "RestoreAzureDiskConfig": RestoreAzureDiskConfig,
  "RestoreAzureDiskRequest": RestoreAzureDiskRequest,
  "RestoreAzureInstanceDiskInput": RestoreAzureInstanceDiskInput,
  "RestoreAzureSqlDatabaseRequest": RestoreAzureSqlDatabaseRequest,
  "RestoreAzureSqlVmPitrRequest": RestoreAzureSqlVmPitrRequest,
  "RestoreAzureVMInstanceConfig": RestoreAzureVMInstanceConfig,
  "RestoreAzureVmInstanceRequest": RestoreAzureVmInstanceRequest,
  "RestoreBigQueryDatasetRequest": RestoreBigQueryDatasetRequest,
  "RestoreBucketRequest": RestoreBucketRequest,
  "RestoreDbToRdsInstanceRequest": RestoreDbToRdsInstanceRequest,
  "RestoreDbToRdsSnapshotRequest": RestoreDbToRdsSnapshotRequest,
  "RestoreDynamoDBTableRequest": RestoreDynamoDBTableRequest,
  "RestoreDynamoDBToExistingTableRequest": RestoreDynamoDBToExistingTableRequest,
  "RestoreDynamoDbTableConfig": RestoreDynamoDbTableConfig,
  "RestoreEFSRequest": RestoreEFSRequest,
  "RestoreEbsVolumeConfig": RestoreEbsVolumeConfig,
  "RestoreEc2InstanceConfig": RestoreEc2InstanceConfig,
  "RestoreEksNamespaceConfig": RestoreEksNamespaceConfig,
  "RestoreEksNamespaceInput": RestoreEksNamespaceInput,
  "RestoreEksNamespaceVolumeInput": RestoreEksNamespaceVolumeInput,
  "RestoreFSxRequest": RestoreFSxRequest,
  "RestoreFilesRequest": RestoreFilesRequest,
  "RestoreGceDiskConfig": RestoreGceDiskConfig,
  "RestoreGceInstanceConfig": RestoreGceInstanceConfig,
  "RestoreGcpCloudSqlDatabaseConfig": RestoreGcpCloudSqlDatabaseConfig,
  "RestoreGcpCloudSqlRequest": RestoreGcpCloudSqlRequest,
  "RestoreGcpDiskRequest": RestoreGcpDiskRequest,
  "RestoreGcpInstanceDiskInput": RestoreGcpInstanceDiskInput,
  "RestoreGcpVmInstanceRequest": RestoreGcpVmInstanceRequest,
  "RestoreImageImageDeviceInput": RestoreImageImageDeviceInput,
  "RestoreImageImageInput": RestoreImageImageInput,
  "RestoreImageInput": RestoreImageInput,
  "RestoreImageVolumeInput": RestoreImageVolumeInput,
  "RestoreInstanceImageDeviceInput": RestoreInstanceImageDeviceInput,
  "RestoreInstanceImageInput": RestoreInstanceImageInput,
  "RestoreInstanceVolumeInput": RestoreInstanceVolumeInput,
  "RestoreJob": RestoreJob,
  "RestoreJobConfiguration": RestoreJobConfiguration,
  "RestoreJobInitiationResponse": RestoreJobInitiationResponse,
  "RestoreJobTypeFilters": RestoreJobTypeFilters,
  "RestoreJobsFilterConditions": RestoreJobsFilterConditions,
  "RestoreRdsInstanceClasses": RestoreRdsInstanceClasses,
  "RestoreRdsInstanceConfig": RestoreRdsInstanceConfig,
  "RestoreRdsNativePitrRequest": RestoreRdsNativePitrRequest,
  "RestoreRdsSubnetGroups": RestoreRdsSubnetGroups,
  "RestoreRdsSubnetGroupsRdsSubnetGroupsInner": RestoreRdsSubnetGroupsRdsSubnetGroupsInner,
  "RestoreResult": RestoreResult,
  "RestoreSecurityGroups": RestoreSecurityGroups,
  "RestoreSecurityGroupsSecurityGroupsInner": RestoreSecurityGroupsSecurityGroupsInner,
  "RestoreVolumeToEbsRequest": RestoreVolumeToEbsRequest,
  "RestoreVolumeToEbsSnapshotRequest": RestoreVolumeToEbsSnapshotRequest,
  "Role": Role,
  "RoleAccessGroupCondition": RoleAccessGroupCondition,
  "S3Bucket": S3Bucket,
  "S3Buckets": S3Buckets,
  "S3RestoreDestination": S3RestoreDestination,
  "S3RestoreTarget": S3RestoreTarget,
  "S3SourceProperties": S3SourceProperties,
  "SAMLCallback400Response": SAMLCallback400Response,
  "SAMLCallback401Response": SAMLCallback401Response,
  "SAMLCallback500Response": SAMLCallback500Response,
  "SamlIdentityProvider": SamlIdentityProvider,
  "SamlIdentityProviderConfigsResponse": SamlIdentityProviderConfigsResponse,
  "SapHanaInstance": SapHanaInstance,
  "SapHanaRestoreProperties": SapHanaRestoreProperties,
  "SaveCloudResourceSecurityPropertiesRequest": SaveCloudResourceSecurityPropertiesRequest,
  "SaveNotebookContentRequest": SaveNotebookContentRequest,
  "SavedQuery": SavedQuery,
  "ScanJob": ScanJob,
  "SchemaRecord": SchemaRecord,
  "SearchDBResponse": SearchDBResponse,
  "SearchFilesResponse": SearchFilesResponse,
  "SearchInput": SearchInput,
  "SearchLogsHistogramInput": SearchLogsHistogramInput,
  "SearchLogsHistogramResponse": SearchLogsHistogramResponse,
  "SearchLogsInput": SearchLogsInput,
  "SearchLogsResponse": SearchLogsResponse,
  "SearchResources200Response": SearchResources200Response,
  "SearchResources200ResponseTablesInner": SearchResources200ResponseTablesInner,
  "SearchResources200ResponseTablesInnerResource": SearchResources200ResponseTablesInnerResource,
  "SearchResources200ResponseTablesInnerSnapshots": SearchResources200ResponseTablesInnerSnapshots,
  "SearchResources200ResponseTablesInnerSource": SearchResources200ResponseTablesInnerSource,
  "SearchResources200ResponseTablesInnerTablesInner": SearchResources200ResponseTablesInnerTablesInner,
  "SearchResources200ResponseTablesInnerTablesInnerColumnsInner": SearchResources200ResponseTablesInnerTablesInnerColumnsInner,
  "SearchResourcesRequest": SearchResourcesRequest,
  "SecurityInformation": SecurityInformation,
  "SecurityPlan": SecurityPlan,
  "SecurityPlanEnabledResponse": SecurityPlanEnabledResponse,
  "SecurityScan": SecurityScan,
  "SecurityScanExample": SecurityScanExample,
  "SecurityScanResult": SecurityScanResult,
  "SecurityScansSummaryResponse": SecurityScansSummaryResponse,
  "SecuritySummary": SecuritySummary,
  "SendMessageToAI400Response": SendMessageToAI400Response,
  "SendMessageToAIRequest": SendMessageToAIRequest,
  "SensitivityAnnotation": SensitivityAnnotation,
  "ServiceProviderDetails": ServiceProviderDetails,
  "Session": Session,
  "SeverityFilters": SeverityFilters,
  "Snapshot": Snapshot,
  "SnapshotDateFilters": SnapshotDateFilters,
  "SnapshotFilterConditions": SnapshotFilterConditions,
  "SnapshotIdFilters": SnapshotIdFilters,
  "SnapshotLocation": SnapshotLocation,
  "SnapshotReference": SnapshotReference,
  "SnapshotStorage": SnapshotStorage,
  "SnapshotsSummaryResponse": SnapshotsSummaryResponse,
  "SnowflakeIntegrationConfig": SnowflakeIntegrationConfig,
  "SortBackupJobBy": SortBackupJobBy,
  "SortLogsBy": SortLogsBy,
  "SortResourceBy": SortResourceBy,
  "SortRestoreAccountsBy": SortRestoreAccountsBy,
  "SortRestoreJobBy": SortRestoreJobBy,
  "SortSnapshotsBy": SortSnapshotsBy,
  "SortSourceAccountsBy": SortSourceAccountsBy,
  "SourceAccount": SourceAccount,
  "SourceAccountAttributesInput": SourceAccountAttributesInput,
  "SourceAccountCloudAttributes": SourceAccountCloudAttributes,
  "SourceAccountMetricsConfig": SourceAccountMetricsConfig,
  "SourceAccountProviderIdFilters": SourceAccountProviderIdFilters,
  "SourceAccountsFilterConditions": SourceAccountsFilterConditions,
  "SourceAwsOrganizationalUnit": SourceAwsOrganizationalUnit,
  "SourceRegionFilters": SourceRegionFilters,
  "SourceStorage": SourceStorage,
  "SourceStorageBackupStatus": SourceStorageBackupStatus,
  "SparkEngine": SparkEngine,
  "SparkJob": SparkJob,
  "SparkJobRetryPolicy": SparkJobRetryPolicy,
  "SparkJobSparkSubmitParams": SparkJobSparkSubmitParams,
  "SqlEngine": SqlEngine,
  "SqlQueryExecution": SqlQueryExecution,
  "SqlQueryExecutionResult": SqlQueryExecutionResult,
  "SqlQueryExecutionResultColumn": SqlQueryExecutionResultColumn,
  "SqlVmNetworkInfo": SqlVmNetworkInfo,
  "SsoIntegrationSettings": SsoIntegrationSettings,
  "StackNameFilters": StackNameFilters,
  "StandardBackupPolicyPlan": StandardBackupPolicyPlan,
  "StandardBackupScheduleConfig": StandardBackupScheduleConfig,
  "StandardBackupSchedules": StandardBackupSchedules,
  "StandardIntervalConfig": StandardIntervalConfig,
  "StartNotebookSessionInput": StartNotebookSessionInput,
  "StartSparkJobInput": StartSparkJobInput,
  "StartSqlQueryExecutionInput": StartSqlQueryExecutionInput,
  "StartTimeDateFilters": StartTimeDateFilters,
  "StatusCodeFilters": StatusCodeFilters,
  "StorageAccountContainerRestoreDestination": StorageAccountContainerRestoreDestination,
  "StorageAccountRestoreTarget": StorageAccountRestoreTarget,
  "StorageGateway": StorageGateway,
  "StorageGatewayDetails": StorageGatewayDetails,
  "SubnetConfig": SubnetConfig,
  "SubnetFilters": SubnetFilters,
  "SubnetPerAvailabilityZone": SubnetPerAvailabilityZone,
  "SubnetsCondition": SubnetsCondition,
  "SupportedProviders": SupportedProviders,
  "TableRecord": TableRecord,
  "TagKeyValue": TagKeyValue,
  "TagKeyValuesCondition": TagKeyValuesCondition,
  "TagKeyValuesFilters": TagKeyValuesFilters,
  "TagKeysCondition": TagKeysCondition,
  "TagKeysFilters": TagKeysFilters,
  "TakeNativeSnapshotRequest": TakeNativeSnapshotRequest,
  "TakeSnapshotRequest": TakeSnapshotRequest,
  "TakeSnapshotResponse": TakeSnapshotResponse,
  "TimeFrame": TimeFrame,
  "TimeOfDay": TimeOfDay,
  "TimeOfYear": TimeOfYear,
  "TokenResponse": TokenResponse,
  "UnifiedDBRecord": UnifiedDBRecord,
  "UnifiedDBServerRecord": UnifiedDBServerRecord,
  "UnifiedDatabaseRecord": UnifiedDatabaseRecord,
  "UnifiedSchemaRecord": UnifiedSchemaRecord,
  "UnifiedTableRecord": UnifiedTableRecord,
  "UpPulumiStacksResponse": UpPulumiStacksResponse,
  "UpdateApiCredentialsRequest": UpdateApiCredentialsRequest,
  "UpdateBackupPolicyRequest": UpdateBackupPolicyRequest,
  "UpdateBackupPolicyResponse": UpdateBackupPolicyResponse,
  "UpdateCloudResourceConfigurationRequest": UpdateCloudResourceConfigurationRequest,
  "UpdateCloudResourceConfigurationRequestCdcBackup": UpdateCloudResourceConfigurationRequestCdcBackup,
  "UpdateCloudResourceConfigurationRequestInventoryBackup": UpdateCloudResourceConfigurationRequestInventoryBackup,
  "UpdateControlViolationInput": UpdateControlViolationInput,
  "UpdateDashboardInput": UpdateDashboardInput,
  "UpdateDlsgPolicyRequest": UpdateDlsgPolicyRequest,
  "UpdateDlsgPolicyResponse": UpdateDlsgPolicyResponse,
  "UpdateGraphInput": UpdateGraphInput,
  "UpdateIdpGroupRequest": UpdateIdpGroupRequest,
  "UpdateIdpGroupResponse": UpdateIdpGroupResponse,
  "UpdateIntegrationRequest": UpdateIntegrationRequest,
  "UpdateIntegrationResponse": UpdateIntegrationResponse,
  "UpdateJobTemplateInput": UpdateJobTemplateInput,
  "UpdateNotebookInput": UpdateNotebookInput,
  "UpdateProjectConfigurationKeyRequest": UpdateProjectConfigurationKeyRequest,
  "UpdatePulumiConfigurationRequest": UpdatePulumiConfigurationRequest,
  "UpdateResourceSecurityScansExclusionRequest": UpdateResourceSecurityScansExclusionRequest,
  "UpdateRestoreAccountConnectivityConfigRequest": UpdateRestoreAccountConnectivityConfigRequest,
  "UpdateRestoreAccountConnectivityConfigResponse": UpdateRestoreAccountConnectivityConfigResponse,
  "UpdateRoleRequest": UpdateRoleRequest,
  "UpdateRoleResponse": UpdateRoleResponse,
  "UpdateSamlIdentityProviderInput": UpdateSamlIdentityProviderInput,
  "UpdateSavedQueryInput": UpdateSavedQueryInput,
  "UpdateSessionRequest": UpdateSessionRequest,
  "UpdateShouldFullBackupResourceRequest": UpdateShouldFullBackupResourceRequest,
  "UpdateUserInput": UpdateUserInput,
  "UpdateVaultRequest": UpdateVaultRequest,
  "UpdateVaultResponse": UpdateVaultResponse,
  "UpdateViewerRoleRequest": UpdateViewerRoleRequest,
  "Usage": Usage,
  "User": User,
  "UserIdFilters": UserIdFilters,
  "VNetConfig": VNetConfig,
  "ValidateResourceConfigurationRequest": ValidateResourceConfigurationRequest,
  "ValidateResourceConfigurationResponse": ValidateResourceConfigurationResponse,
  "VaultFilters": VaultFilters,
  "VaultMetadataReplicationConfig": VaultMetadataReplicationConfig,
  "VaultNotificationArguments": VaultNotificationArguments,
  "VaultProviderAttributes": VaultProviderAttributes,
  "VaultProviderAttributesInput": VaultProviderAttributesInput,
  "VaultSnapshotCount": VaultSnapshotCount,
  "Viewer": Viewer,
  "ViolationsDetectionNotificationArguments": ViolationsDetectionNotificationArguments,
  "VirtualMachineRestoreDestination": VirtualMachineRestoreDestination,
  "VisualizationHistogramSeries": VisualizationHistogramSeries,
  "VisualizationHistogramTimePoint": VisualizationHistogramTimePoint,
  "VisualizationLabel": VisualizationLabel,
  "VolumeSettings": VolumeSettings,
  "VpcCondition": VpcCondition,
  "VpcPropertyFilters": VpcPropertyFilters,
  "WeeklyConfig": WeeklyConfig,
  "Workspace": Workspace,
  "YearlySnapshotDistribution": YearlySnapshotDistribution,
}

export class ObjectSerializer {
  public static findCorrectType(data: any, expectedType: string) {
    if (data == undefined) {
      return expectedType;
    } else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
      return expectedType;
    } else if (expectedType === "Date") {
      return expectedType;
    } else {
      if (enumsMap.has(expectedType)) {
        return expectedType;
      }

      if (!typeMap[expectedType]) {
        return expectedType; // w/e we don't know the type
      }

      // Check the discriminator
      let discriminatorProperty = typeMap[expectedType].discriminator;
      if (discriminatorProperty == null) {
        return expectedType; // the type does not have a discriminator. use it.
      } else {
        if (data[discriminatorProperty]) {
          var discriminatorType = data[discriminatorProperty];
          if(typeMap[discriminatorType]){
            return discriminatorType; // use the type given in the discriminator
          } else {
            return expectedType; // discriminator did not map to a type
          }
        } else {
          return expectedType; // discriminator was not present (or an empty string)
        }
      }
    }
  }

  public static serialize(data: any, type: string, format: string) {
    if (data === undefined || data === null || primitives.includes(type.toLowerCase())) {
      return data;
    } else if (type.startsWith("Array<", 0)) { 
      let subType: string = type.replace("Array<", ""); // Array<Type> => Type>
      subType = subType.substring(0, subType.length - 1); // Type> => Type
      let transformedData: any[] = [];
      for (let date of data) {
        transformedData.push(ObjectSerializer.serialize(date, subType, format));
      }
      return transformedData;
    } else if (type === "Date") {
      if (format == "date") {
        let month = data.getMonth()+1
        month = month < 10 ? "0" + month.toString() : month.toString()
        let day = data.getDate();
        day = day < 10 ? "0" + day.toString() : day.toString();

        return data.getFullYear() + "-" + month + "-" + day;
      } else {
        return data.toISOString();
      }
    } else {
      if (enumsMap.has(type)) {
        return data;
      }
      if (!typeMap[type]) { // in case we dont know the type
        return data;
      }

      // Get the actual type of this object
      type = this.findCorrectType(data, type);

      // get the map for the correct type.
      let attributeTypes = typeMap[type].getAttributeTypeMap();
      let instance: {[index: string]: any} = {};
      for (let attributeType of attributeTypes) {
        instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type, attributeType.format);
      }
      return instance;
    }
  }

  public static deserialize(data: any, type: string, format: string) {
    // polymorphism may change the actual type.
    type = ObjectSerializer.findCorrectType(data, type);
    if (data == undefined) {
      return data;
    } else if (primitives.indexOf(type.toLowerCase()) !== -1) {
      return data;
    } else if (type.lastIndexOf("Array<", 0) === 0) { // string.startsWith pre es6
      let subType: string = type.replace("Array<", ""); // Array<Type> => Type>
      subType = subType.substring(0, subType.length - 1); // Type> => Type
      let transformedData: any[] = [];
      for (let date of data) {
        transformedData.push(ObjectSerializer.deserialize(date, subType, format));
      }
      return transformedData;
    } else if (type === "Date") {
      return new Date(data);
    } else {
      if (enumsMap.has(type)) {// is Enum
        return data;
      }

      if (!typeMap[type]) { // dont know the type
        return data;
      }
      let instance = new typeMap[type]();
      let attributeTypes = typeMap[type].getAttributeTypeMap();
      for (let attributeType of attributeTypes) {
        let value = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type, attributeType.format);
        if (value !== undefined) {
          instance[attributeType.name] = value;
        }
      }
      return instance;
    }
  }

  /**
   * From a list of possible media types, choose the one we can handle best.
   *
   * The order of the given media types does not have any impact on the choice
   * made.
   */
  public static getPreferredMediaType(mediaTypes: Array<string>): string {
    return "application/json";
  }

}
